/* CDX Product (PDP) — gallery, variants, cart, AVIS modal */
(function () {
  'use strict';

  /* Mehrsprachigkeit/CH (30.09.2026): Zahlenformat nach Seitensprache, Waehrung des aktiven Markts (CHF in der Schweiz) */
  var euro;
  try {
    euro = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  } catch (e) {
    euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  }
  function money(cents) { return euro.format((cents || 0) / 100); }

  function initPDP(root) {
    if (root.__cdxInit) return;
    root.__cdxInit = true;

    var variants = [];
    try { variants = JSON.parse(root.dataset.variants || '[]'); } catch (e) { variants = []; }
    /* Lagerstatus und Lieferzeit je Variante, vorberechnet in der Section (09.09.2026) */
    var variantDelivery = {};
    try { var vdNode = root.querySelector('[data-variant-delivery]'); if (vdNode) variantDelivery = JSON.parse(vdNode.textContent || '{}'); } catch (e) { variantDelivery = {}; }
    var variantStufe = null;
    try { var vsNode = root.querySelector('[data-variant-stufe]'); if (vsNode) variantStufe = JSON.parse(vsNode.textContent || '{}'); } catch (e) { variantStufe = null; }

    function applyStufe(v) {
      var st = variantStufe && v ? variantStufe[String(v.id)] : null;
      if (!st) return;
      root.querySelectorAll('[data-var-st-bb]').forEach(function (el) {
        var strong = document.createElement('strong');
        strong.textContent = st.t || '';
        el.textContent = '';
        el.appendChild(strong);
        if (st.u) el.appendChild(document.createTextNode(' · ' + st.u));
      });
      root.querySelectorAll('[data-var-v1]').forEach(function (el) { el.textContent = st.v1 || ''; });
      document.querySelectorAll('[data-ds-var-st]').forEach(function (el) { el.textContent = (st.t || '') + (st.w ? ' · ' + st.w : ''); });
      document.querySelectorAll('[data-ds-var-v1]').forEach(function (el) { el.textContent = st.v1 || ''; });
      document.querySelectorAll('[data-ds-var-v2]').forEach(function (el) { el.textContent = st.v2 || ''; });
    }

    /* ---------- Gallery (Slider + Klick/Tap-Zoom) ---------- */
    (function () {
      var main = root.querySelector('[data-gal-main]');
      var track = root.querySelector('[data-gal-track]');
      var thumbsWrap = root.querySelector('[data-gal-thumbs]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gal-thumb]'));
      var stages = Array.prototype.slice.call(root.querySelectorAll('[data-gal-stage]'));
      var ixEl = root.querySelector('[data-gal-ix]');
      var totalEl = root.querySelector('[data-gal-total]');
      var prevBtn = root.querySelector('[data-gal-prev]');
      var nextBtn = root.querySelector('[data-gal-next]');
      var count = Math.max(thumbs.length, stages.length);
      var cur = 0, zoomed = false;
      /* Codext 07.10.2026 (Performance): Nur das erste Galeriebild laedt mit hoher Prioritaet,
         die uebrigen sind loading="lazy" (sections/cdx-product.liquid). Damit Wischen und
         Variantenwechsel trotzdem sofort Bilder zeigen, werden sie nach dem Seitenaufbau im
         Leerlauf vorgeladen. 27.10.2026: im Leerlauf nur die naechsten zwei, alle uebrigen erst bei
         der ersten Bedienung der Seite (bis zu 12 Bilder a ~130 KB kosteten mobil sonst Datenvolumen). */
      (function () {
        var warm = function (n) {
          stages.slice(0, n).forEach(function (st) {
            var im = st.querySelector('img[loading="lazy"]');
            if (im) im.loading = 'eager';
          });
        };
        var later = function () {
          var next = function () { warm(3); };
          if (window.requestIdleCallback) requestIdleCallback(next, { timeout: 3000 });
          else setTimeout(next, 1500);
          ['pointerdown', 'keydown'].forEach(function (ev) {
            document.addEventListener(ev, function () { warm(stages.length); }, { once: true, passive: true });
          });
        };
        if (document.readyState === 'complete') later();
        else window.addEventListener('load', later, { once: true });
      })();
      var ZOOM = 2.4;
      /* Sichtbare Medien als Indexliste — der Farbfilter blendet auch mittendrin
         aus, ein zusammenhaengender Bereich reicht dafuer nicht. null = alle. */
      var group = null;

      // Variantenbild-Modus + Variante->Medium-Map
      var vMode = root.dataset.variantImageMode || 'off';
      var colorIdx = parseInt(root.dataset.colorOptionIndex, 10);
      /* Zweite Achse: das Schloss. lockWords sind die Schluesselwoerter aus der
         Theme-Einstellung "Schloss-Dateinamen", in derselben Reihenfolge wie dort -
         erster Teiltreffer im Optionswert gewinnt. Damit fallen "Zahlenschloss",
         "mech. Zahlenschloss" und "Zahlenschloss mit Notschluessel" auf denselben
         Schluessel, ohne dass jede Schreibweise gepflegt werden muss. */
      var lockIdx = parseInt(root.dataset.lockOptionIndex, 10);
      var lockWords = (root.dataset.lockKeywords || '').split('|').filter(Boolean);
      /* ---- Tuerzustand aus dem Dateinamen (Punkt 28, 02.09.2026) ----------
         Ein Klick auf die FARBE soll den offenen Schrank zeigen, ein Klick auf
         das SCHLOSS den geschlossenen: beim Schloss will der Kunde die Front
         sehen, an der es sitzt.

         Das Vokabular ist nicht erfunden, sondern im Katalog ausgezaehlt
         (272 Produkte, 5735 Bilder, 02.09.2026). Hinter dem Schlosskuerzel
         stehen: zu 595, offen-voll 340, offen-leer 339, geschlossen 254,
         halboffen 15. Es gibt also ZWEI Woerter fuer geschlossen — "zu" und
         "geschlossen" — und "halboffen" zaehlt als offen. Wer nur auf "-zu"
         geprueft haette, haette ueber 250 Bilder uebersehen.

         Verglichen wird segmentweise und nicht per Teiltreffer: "zu" steckt
         sonst in "zubehoer", und "offen" in "geoeffnet" waere Zufall. Der
         Dateiname wird vorher wie ueberall normalisiert, Unterstriche zu
         Trennstrichen — der Katalog schreibt "…-zu_1".

         85 Prozent der Produkte fuehren beide Zustaende. Wo einer fehlt, bleibt
         es beim ersten Treffer; die neun Produkte ganz ohne sind
         Schluesseltafeln, die haben keine Tuer. */
      var ZU_WORTE = ['zu', 'geschlossen'];
      var OFFEN_WORTE = ['offen', 'halboffen'];
      function dateiSegmente(url) {
        return String(url || '').split('/').pop().split('?')[0].toLowerCase()
          .replace(/\.[a-z0-9]+$/, '').replace(/_/g, '-').split('-');
      }
      function stageZustand(i) {
        var st = stages[i];
        var im = st && st.querySelector('img');
        if (!im) return '';
        var seg = dateiSegmente(im.getAttribute('src'));
        for (var z = 0; z < ZU_WORTE.length; z++) if (seg.indexOf(ZU_WORTE[z]) !== -1) return 'zu';
        for (var o = 0; o < OFFEN_WORTE.length; o++) if (seg.indexOf(OFFEN_WORTE[o]) !== -1) return 'offen';
        return '';
      }
      /* Erster Treffer im Wunschzustand, sonst der erste ueberhaupt. */
      function waehleZustand(indices, wunsch) {
        if (!indices || !indices.length) return null;
        for (var i = 0; i < indices.length; i++) if (stageZustand(indices[i]) === wunsch) return indices[i];
        return indices[0];
      }
      /* Welche Achse hat der Kunde zuletzt angefasst? Die Galerie erfaehrt vom
         Variantenwechsel nur das Ergebnis, nicht den Weg dorthin. */
      var letzteAchse = '';
      /* Solange niemand ein Schloss angefasst hat, ist die Markierung in der
         Schloss-Reihe nur eine Voreinstellung. Danach gilt sie als Wahl und
         ueberlebt einen Farbwechsel — gleiche Regel wie auf der Kachel. */
      var schlossGewaehlt = false;
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-option-value]');
        if (!b || !root.contains(b)) return;
        var pos = parseInt(b.getAttribute('data-position'), 10) - 1;
        letzteAchse = pos === lockIdx ? 'schloss' : (pos === colorIdx ? 'farbe' : '');
        if (letzteAchse === 'schloss') schlossGewaehlt = true;
      }, true);

      function lockKeyOf(variant) {
        if (!(lockIdx >= 0) || !variant || !variant.options) return '';
        var v = String(variant.options[lockIdx] || '').toLowerCase();
        for (var i = 0; i < lockWords.length; i++) { if (v.indexOf(lockWords[i]) !== -1) return lockWords[i]; }
        return '';
      }
      var vMap = {}; try { var mn = root.querySelector('[data-cdx-variant-media]'); if (mn) vMap = JSON.parse(mn.textContent); } catch (e) {}
      var mediaIndex = {}; stages.forEach(function (st, i) { mediaIndex[st.dataset.galStage] = i; });
      function computeAnchors() { var set = {}; Object.keys(vMap).forEach(function (vid) { var m = vMap[vid]; if (m && mediaIndex[m] != null) set[mediaIndex[m]] = 1; }); return Object.keys(set).map(Number).sort(function (a, b) { return a - b; }); }
      var anchors = computeAnchors();
      function visible() {
        if (group && group.length) return group;
        var all = []; for (var i = 0; i < count; i++) all.push(i);
        return all;
      }
      function colorKey(val) { return String(val || '').toLowerCase().trim().replace(/\s+/g, '-'); }

      function clamp(v) { return Math.max(0, Math.min(100, v)); }
      function curImg() { var s = stages[cur]; return s ? s.querySelector('img.gal-img') : null; }
      /* Codext 14.10.2026: Position im Track = Position in der SICHTBAREN Liste.
         Vorher lief der Track ueber den absoluten Index, ausgeblendete Medien
         blieben als Stage im Track stehen. Beim Wischen zog dann der Nachbar
         herein, den die Farbe gerade ausgeblendet hat (Merkur 15: neben dem
         3D-Modell das graphitgraue Foto, obwohl Lichtgrau gewaehlt war). */
      function trackPos() { var p = visible().indexOf(cur); return p < 0 ? 0 : p; }
      function isModel(i) { var s = stages[i]; return !!(s && s.dataset.mediaType === 'model'); }
      /* instant=true schaltet den Uebergang fuer genau diesen Sprung ab.
         Gebraucht wird das beim Wechsel ueber die Swatches: der Track schiebt
         sonst seitlich durch jedes Bild dazwischen, und bei sieben Fotos sieht
         man beim Klick auf eine Farbe erst fuenf fremde vorbeirauschen
         (Wunsch Chris, Punkt 80). Blaettern und Wischen behalten die Animation,
         dort ist die Bewegung die Antwort auf die Geste.
         Das Auslesen von offsetWidth erzwingt das Layout, bevor die Klasse
         wieder faellt - ohne diese Zeile wuerde der Uebergang doch greifen. */
      function setTrack(instant) {
        if (!track) return;
        if (instant) track.classList.add('is-instant');
        track.style.transform = 'translateX(-' + (trackPos() * 100) + '%)';
        if (instant) { void track.offsetWidth; track.classList.remove('is-instant'); }
      }
      function unzoom() {
        zoomed = false;
        if (main) main.classList.remove('is-zooming');
        stages.forEach(function (st) { var im = st.querySelector('img.gal-img'); if (im) im.style.transform = ''; });
      }
      function zoomAt(clientX, clientY) {
        var img = curImg(); if (!img) return;
        var r = img.getBoundingClientRect();
        img.style.transformOrigin = clamp(((clientX - r.left) / r.width) * 100) + '% ' + clamp(((clientY - r.top) / r.height) * 100) + '%';
        img.style.transform = 'scale(' + ZOOM + ')';
        zoomed = true; if (main) main.classList.add('is-zooming');
      }
      function show(idx, instant) {
        if (count < 1) return;
        var list = visible();
        if (list.indexOf(idx) === -1) {
          // ausgeblendetes Medium -> naechstes sichtbares nehmen
          var next = list[0];
          for (var v = 0; v < list.length; v++) { if (list[v] >= idx) { next = list[v]; break; } }
          idx = next;
        }
        cur = idx;
        unzoom(); setTrack(instant);
        thumbs.forEach(function (t, i) { t.classList.toggle('active', i === cur); });
        stages.forEach(function (st, i) { st.classList.toggle('active', i === cur); });
        // 3D-Stage: keine Lupe, Ziehen dreht das Modell (CSS .gal-main.is-model)
        if (main) main.classList.toggle('is-model', isModel(cur));
        if (ixEl) ixEl.textContent = ('0' + (list.indexOf(cur) + 1)).slice(-2);
        // aktives Thumbnail nur INNERHALB des Thumb-Containers zentrieren (Seite nicht scrollen)
        var at = thumbs[cur];
        if (at && thumbsWrap) {
          /* Die Thumbnail-Leiste folgt derselben Regel: gleitet sie weiter,
             waehrend das Hauptbild springt, bleibt eine Animation stehen, die
             genau derselbe Klick ausgeloest hat. */
          var beh = instant ? 'auto' : 'smooth';
          // Achse je nach Layout: vertikale Thumbs (links) -> scrollTop, sonst scrollLeft
          if (thumbsWrap.scrollHeight > thumbsWrap.clientHeight + 1) {
            var tTop = thumbsWrap.scrollTop + at.getBoundingClientRect().top - thumbsWrap.getBoundingClientRect().top - (thumbsWrap.clientHeight - at.clientHeight) / 2;
            if (thumbsWrap.scrollTo) thumbsWrap.scrollTo({ top: tTop, behavior: beh });
            else thumbsWrap.scrollTop = tTop;
          } else {
            var target = thumbsWrap.scrollLeft + at.getBoundingClientRect().left - thumbsWrap.getBoundingClientRect().left - (thumbsWrap.clientWidth - at.clientWidth) / 2;
            if (thumbsWrap.scrollTo) thumbsWrap.scrollTo({ left: target, behavior: beh });
            else thumbsWrap.scrollLeft = target;
          }
        }
      }
      function setGroup(list, focus, instant) {
        group = (list && list.length) ? list : null;
        var vis = visible();
        /* Nur die Thumbnails werden ausgeblendet: die Stages bleiben im Track
           stehen, weil setTrack() ueber den absoluten Index verschiebt. */
        thumbs.forEach(function (t, i) { t.style.display = vis.indexOf(i) !== -1 ? '' : 'none'; });
        /* Codext 14.10.2026: Stages jetzt mit ausblenden, der Track rechnet ueber
           trackPos() (Position in der sichtbaren Liste), siehe oben. */
        stages.forEach(function (st, i) { st.style.display = vis.indexOf(i) !== -1 ? '' : 'none'; });
        if (totalEl) totalEl.textContent = ('0' + vis.length).slice(-2);
        sync360();
        var multi = vis.length > 1;
        if (prevBtn) prevBtn.style.display = multi ? '' : 'none';
        if (nextBtn) nextBtn.style.display = multi ? '' : 'none';
        show(focus != null && vis.indexOf(focus) !== -1 ? focus : (vis.indexOf(cur) !== -1 ? cur : vis[0]), instant);
      }
      /* Blaettern laeuft ueber die Position in der sichtbaren Liste, damit
         ausgeblendete Medien uebersprungen werden. */
      function step(delta) {
        var list = visible();
        if (!list.length) return;
        var pos = list.indexOf(cur);
        if (pos === -1) pos = 0;
        pos = (pos + delta % list.length + list.length) % list.length;
        show(list[pos]);
      }
      /* Jeder Weg hier drin springt ohne Uebergang: applyVariant laeuft nur beim
         Variantenwechsel (Swatch-Klick) und einmal beim Laden der Seite. Beides
         soll das Bild sofort zeigen. */
      function applyVariant(variant) {
        if (!variant || vMode === 'off') return;
        var mid = vMap[variant.id];
        var idx = (mid && mediaIndex[mid] != null) ? mediaIndex[mid] : null;

        if (vMode === 'color') {
          // Nur Fotos der gewaehlten Farbe; Medien ohne Farbbezug bleiben stehen.
          if (!(colorIdx >= 0) || !variant.options) return;
          var key = colorKey(variant.options[colorIdx]);
          var list = [];
          stages.forEach(function (st, i) {
            var c = st.getAttribute('data-gal-color');
            if (!c || c === key) list.push(i);
          });
          /* Das Schloss steuert, WELCHES Foto vorne liegt - es filtert die Galerie
             nicht. Bewusst so: das Kuerzel im Dateinamen unterscheidet nur die
             Frontansichten (…-db-zu, …-elo-zu, …-kaba-zu). Die Innenaufnahmen
             heissen …-db-offen-voll und …-db-offen-leer, tragen also db, zeigen
             aber das Innere, das bei jedem Schloss gleich aussieht. Wer nach
             Schloss filtert, wirft genau die weg: beim Hades 16-2 blieb von sieben
             Fotos eines uebrig. Also nur den Fokus setzen, die Farbgruppe bleibt
             vollstaendig. Gibt es kein Foto zum Schloss, aendert sich gar nichts.
             Das Variantenbild taugt als Anker nicht - es zeigt im Katalog bei rund
             vier von fuenf Varianten ein anderes Schloss. */
          var lk = lockKeyOf(variant);
          if (lk) {
            /* 3D-Modelle tragen seit 14.10.2026 auch Farbe/Schloss, als Fokus
               beim Variantenwechsel taugen sie nicht - vorne liegt immer ein Foto. */
            var exact = list.filter(function (i) { return stages[i].getAttribute('data-gal-schloss') === lk && !isModel(i); });
            /* Erst die Fotos nehmen, die AUCH die gewaehlte Farbe tragen.
               Ohne das gewann beim Elios 70 das Werbebild rfid-usp-1-3.jpg gegen
               elios-70-gg-rfid.jpg: es traegt rfid im Namen, aber keine Farbe -
               und farblose Medien bleiben in der Farbliste bewusst stehen, damit
               Detailaufnahmen nicht verschwinden. Fuer den FOKUS taugen sie
               trotzdem nicht, dafuer braucht es das Produktfoto in der richtigen
               Farbe. Gibt es keins, bleibt der alte Weg als Rueckfall.
               (Rueckmeldung Leon, 20.08.2026) */
            var exactFarbe = exact.filter(function (i) { return stages[i].getAttribute('data-gal-color') === key; });
            var treffer = exactFarbe.length ? exactFarbe : exact;
            var keep = idx != null && stages[idx] && stages[idx].getAttribute('data-gal-schloss') === lk
                       && (!exactFarbe.length || stages[idx].getAttribute('data-gal-color') === key);
            /* Beim Schloss-Klick die geschlossene Front bevorzugen: dort sitzt
               das Schloss. "keep" laesst das aktuelle Bild stehen, wenn es schon
               zum Schloss passt — nach einem Schloss-Klick will der Kunde aber
               den Wechsel sehen, deshalb waehlt der Klick auf die Achse neu. */
            if (treffer.length && (!keep || letzteAchse === 'schloss')) {
              idx = letzteAchse === 'schloss' ? waehleZustand(treffer, 'zu') : treffer[0];
            }
          }
          /* Beim Farb-Klick den offenen Schrank zeigen. Nur wenn das Schloss den
             Fokus nicht ohnehin gesetzt hat — sonst ueberschriebe die Farbe die
             engere Wahl. Gesucht wird in den Fotos der gewaehlten Farbe. */
          if (letzteAchse === 'farbe' && !schlossGewaehlt) {
            var farbFotos = list.filter(function (i) { return stages[i].getAttribute('data-gal-color') === key; });
            var offen = waehleZustand(farbFotos.length ? farbFotos : list, 'offen');
            if (offen != null && stageZustand(offen) === 'offen') idx = offen;
          }
          setGroup(list, idx, true);
          return;
        }

        if (idx == null) return;
        if (vMode === 'jump') { show(idx, true); return; }
        var start = 0, end = stages.length; // group: Start = letzter Anker <= idx, Ende = naechster Anker
        for (var a = 0; a < anchors.length; a++) { if (anchors[a] <= idx) start = anchors[a]; if (anchors[a] > idx) { end = anchors[a]; break; } }
        var range = []; for (var r = start; r < end; r++) range.push(r);
        setGroup(range, idx, true);
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
      if (count <= 1) { if (prevBtn) prevBtn.style.display = 'none'; if (nextBtn) nextBtn.style.display = 'none'; }

      // Desktop: Cursor = Lupe (CSS zoom-in). Klick zoomt, Mausbewegung schwenkt, erneuter Klick raus.
      var canHover = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
      if (main && canHover) {
        main.addEventListener('click', function (e) {
          if (e.target.closest('.gal-nav, .badge-360')) return;
          if (!curImg()) return;
          if (zoomed) unzoom(); else zoomAt(e.clientX, e.clientY);
        });
        main.addEventListener('mousemove', function (e) {
          if (!zoomed) return;
          var img = curImg(); if (!img) return;
          var r = img.getBoundingClientRect();
          img.style.transformOrigin = clamp(((e.clientX - r.left) / r.width) * 100) + '% ' + clamp(((e.clientY - r.top) / r.height) * 100) + '%';
        });
        main.addEventListener('mouseleave', unzoom);
      }

      /* Touch: ziehen zum Swipen (Bild folgt dem Finger), Tippen zum Zoomen.
         Codext 14.10.2026 (Video Leon, Merkur 15), drei Fehler behoben:
         1. Tippen auf "360°-Ansicht" oder die Pfeile zoomte erst das Foto, weil
            touchend vor dem click kommt. Bedienelemente laufen jetzt nicht
            mehr durch diesen Handler.
         2. Gezoomt kam man per Tippen nicht mehr heraus: touchstart brach ab,
            touchend fand dragging=false. Jetzt: gezoomt schwenkt Ziehen den
            Ausschnitt, Tippen zoomt heraus (CSS sperrt dafuer das Scrollen).
         3. Auf dem 3D-Modell schob das Drehen gleichzeitig den Track mit, das
            Modell rutschte halb aus dem Bild. Gesten auf dem model-viewer
            gehoeren jetzt dem Modell; Blaettern dort ueber Pfeile/Thumbnails. */
      if (main) {
        var sx = 0, sy = 0, w = 0, dragging = false, moved = false, panning = false;
        var skipTouch = function (e) { return !!(e.target.closest && e.target.closest('.gal-nav, .badge-360, model-viewer, .shopify-model-viewer-ui, video, iframe')); };
        var panTo = function (t) {
          var img = curImg(); if (!img) return;
          var r = img.getBoundingClientRect();
          img.style.transformOrigin = clamp(((t.clientX - r.left) / r.width) * 100) + '% ' + clamp(((t.clientY - r.top) / r.height) * 100) + '%';
        };
        main.addEventListener('touchstart', function (e) {
          dragging = false; panning = false; moved = false;
          if (e.touches.length > 1) return;
          var t = e.touches[0]; sx = t.clientX; sy = t.clientY;
          if (zoomed) { panning = true; return; }
          if (skipTouch(e) || isModel(cur)) return;
          dragging = true;
          w = main.getBoundingClientRect().width;
          if (track) track.classList.add('is-dragging');
        }, { passive: true });
        main.addEventListener('touchmove', function (e) {
          var t = e.touches[0], dx = t.clientX - sx, dy = t.clientY - sy;
          if (panning) {
            if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
            if (moved) panTo(t);
            return;
          }
          if (!dragging) return;
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) {
            moved = true;
            if (track) track.style.transform = 'translateX(calc(-' + (trackPos() * 100) + '% + ' + dx + 'px))';
          }
        }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (track) track.classList.remove('is-dragging');
          if (panning) { panning = false; if (!moved) unzoom(); return; }
          if (!dragging) return; dragging = false;
          var dx = e.changedTouches[0].clientX - sx;
          if (moved && Math.abs(dx) > w * 0.18) { step(dx < 0 ? 1 : -1); }
          else if (!moved) { if (curImg()) zoomAt(e.changedTouches[0].clientX, e.changedTouches[0].clientY); setTrack(); }
          else { setTrack(); }
        }, { passive: true });
        main.addEventListener('touchcancel', function () {
          if (track) track.classList.remove('is-dragging');
          if (dragging) setTrack();
          dragging = false; panning = false;
        }, { passive: true });
      }

      /* 360-Badge -> springt zum 3D-Modell. Codext 14.10.2026: nur Modelle der
         sichtbaren Gruppe zaehlen (bei "Nur Fotos der Farbe" das Modell der
         gewaehlten Farbe); gibt es dort keins, verschwindet der Button. */
      var open360 = root.querySelector('[data-gal-open-360]');
      function firstModel() {
        var list = visible();
        for (var k = 0; k < list.length; k++) { if (isModel(list[k])) return list[k]; }
        return -1;
      }
      function sync360() { if (open360 && stages.length) open360.style.display = firstModel() !== -1 ? '' : 'none'; }
      if (open360) {
        open360.addEventListener('click', function (e) {
          e.stopPropagation();
          var m = firstModel();
          if (m !== -1) show(m);
        });
      }

      // Variantenbild: auf Variantenwechsel reagieren (Event vom Varianten-Code)
      if (vMode !== 'off') {
        document.addEventListener('variant:changed', function (e) { if (e.detail && e.detail.variant) applyVariant(e.detail.variant); });
        // Startvariante: das vollstaendige Objekt, der Farbmodus braucht options[]
        var cvId = Number(root.dataset.currentVariant);
        var startVariant = null;
        try {
          var all = JSON.parse(root.dataset.variants || '[]');
          for (var s0 = 0; s0 < all.length; s0++) { if (all[s0].id === cvId) { startVariant = all[s0]; break; } }
        } catch (err) {}
        if (startVariant) applyVariant(startVariant);
        else if (vMap[cvId]) applyVariant({ id: cvId });
      }

      setTrack();
      /* Codext 07.10.2026: Thumbnail-Leiste freigeben (cdx-product.css blendet sie bis hierhin aus,
         damit das Ausblenden fremder Farben/Schloesser in setGroup kein Layout-Shift wird). */
      if (thumbsWrap) thumbsWrap.classList.add('is-ready');
      window.addEventListener('resize', unzoom);
    })();

    /* ---------- Variants ---------- */
    var form = root.querySelector('#cdx-product-form');
    var idInput = root.querySelector('[data-variant-id]');
    var valueBtns = root.querySelectorAll('[data-option-value]');
    var selected = {}; // position -> value

    root.querySelectorAll('[data-option-position]').forEach(function (sec) {
      var pos = sec.getAttribute('data-option-position');
      var sel = sec.querySelector('.selected, [data-option-value].selected');
      var cur = sec.querySelector('[data-option-value].selected');
      if (cur) selected[pos] = cur.dataset.value;
    });

    function priceForValue(pos, val) {
      var idx = parseInt(pos, 10) - 1;
      var min = null;
      variants.forEach(function (v) {
        if (v.options[idx] === val) { if (min === null || v.price < min) min = v.price; }
      });
      return min;
    }

    function updateDeltas() {
      root.querySelectorAll('[data-option-position]').forEach(function (sec) {
        var pos = sec.getAttribute('data-option-position');
        var sup = sec.querySelectorAll('[data-price-delta]');
        if (!sup.length) return;
        // base = cheapest across all values of this option
        var prices = [];
        sec.querySelectorAll('[data-option-value]').forEach(function (b) {
          var p = priceForValue(pos, b.dataset.value);
          if (p !== null) prices.push(p);
        });
        var base = prices.length ? Math.min.apply(null, prices) : 0;
        sec.querySelectorAll('[data-option-value]').forEach(function (b) {
          var d = b.querySelector('[data-price-delta]');
          if (!d) return;
          var p = priceForValue(pos, b.dataset.value);
          if (p === null) { d.textContent = ''; return; }
          d.textContent = p <= base ? btT('cdx_product.included', 'inkl.') : '+ ' + money(p - base);
        });
      });
    }

    function matchVariant() {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (pos) {
          return v.options[parseInt(pos, 10) - 1] === selected[pos];
        });
      });
    }

    function setUnavailable() {
      // mark values that can't combine with current other selections
      root.querySelectorAll('[data-option-position]').forEach(function (sec) {
        var pos = sec.getAttribute('data-option-position');
        sec.querySelectorAll('[data-option-value]').forEach(function (b) {
          var test = Object.assign({}, selected);
          test[pos] = b.dataset.value;
          var ok = variants.some(function (v) {
            return Object.keys(test).every(function (p) { return v.options[parseInt(p, 10) - 1] === test[p]; }) && v.available;
          });
          b.classList.toggle('unavail', !ok);
        });
      });
    }

    function render() {
      var v = matchVariant();
      // selected labels
      root.querySelectorAll('[data-option-position]').forEach(function (sec) {
        var pos = sec.getAttribute('data-option-position');
        /* Label in der Kopfzeile UND im Dropdown-Knopf (Options-Dropdown, 14.09.2026). */
        sec.querySelectorAll('[data-option-selected]').forEach(function (lbl) { lbl.textContent = selected[pos] || ''; });
        sec.querySelectorAll('[data-option-value]').forEach(function (b) {
          b.classList.toggle('selected', b.dataset.value === selected[pos]);
        });
        /* Aufpreis des gewaehlten Werts in den Dropdown-Knopf spiegeln. */
        var curDelta = sec.querySelector('[data-opt-current-delta]');
        if (curDelta) {
          var selRow = sec.querySelector('[data-option-value].selected [data-price-delta]');
          curDelta.textContent = selRow ? selRow.textContent : '';
        }
        /* Symbol des gewaehlten Werts ebenso (27.10.2026, snippets/cdx-option-icon). */
        var curIc = sec.querySelector('[data-opt-current-icon]');
        var selIc = sec.querySelector('[data-option-value].selected [data-opt-icon]');
        if (curIc && selIc) curIc.innerHTML = selIc.innerHTML;
      });
      setUnavailable();

      if (!v) { return; }
      if (idInput) idInput.value = v.id;
      root.dataset.currentVariant = v.id;
      applyStufe(v);

      var priceEl = root.querySelector('[data-price]');
      var cmpEl = root.querySelector('[data-compare]');
      var saveEl = root.querySelector('[data-save]');
      if (priceEl) priceEl.textContent = money(v.price);
      if (cmpEl) { if (v.compare_at_price > v.price) { cmpEl.textContent = money(v.compare_at_price); cmpEl.style.display = ''; } else { cmpEl.style.display = 'none'; } }
      /* 12.10.2026 Jungjaeger (data-jj): Vergleichspreis kommt aus dem Katalog, nur der Text heisst anders */
      if (saveEl) { if (v.compare_at_price > v.price) { saveEl.textContent = root.hasAttribute('data-jj') ? btT('cdx_product.jj_save', 'Jungjäger-Vorteil: Sie sparen {amount}', { amount: money(v.compare_at_price - v.price) }) : btT('cdx_product.you_save', 'Sie sparen {amount}', { amount: money(v.compare_at_price - v.price) }); saveEl.style.display = ''; } else { saveEl.style.display = 'none'; } }
      root.querySelectorAll('[data-tier-variant]').forEach(function (t) { t.hidden = t.getAttribute('data-tier-variant') !== String(v.id); });

      var stock = root.querySelector('[data-stock]');
      var stockText = root.querySelector('[data-stock-text]');
      var atcBtns = root.querySelectorAll('[data-atc], [data-atc-sticky]');
      var atcLabel = root.querySelector('[data-atc-label]');
      var buyNowBtns = root.querySelectorAll('[data-buy-now]');
      var vInfo = variantDelivery[String(v.id)] || {};
      var dtEl = root.querySelector('[data-delivery-time]');
      var dtVal = root.querySelector('[data-delivery-val]');
      if (v.available) {
        if (stock) {
          stock.removeAttribute('data-soldout');
          if (vInfo.tone) stock.setAttribute('data-tone', vInfo.tone); else stock.removeAttribute('data-tone');
        }
        if (stockText) stockText.textContent = vInfo.status || (stock && stock.getAttribute('data-instock-text')) || btT('cdx_product.in_stock', 'Sofort lieferbar');
        atcBtns.forEach(function (b) { b.disabled = false; });
        if (atcLabel) atcLabel.textContent = btT('cdx_product.add_to_cart', 'In den Warenkorb');
        buyNowBtns.forEach(function (b) { b.disabled = false; });
      } else {
        if (stock) { stock.setAttribute('data-soldout', ''); stock.removeAttribute('data-tone'); }
        if (stockText) stockText.textContent = (stock && stock.getAttribute('data-soldout-text')) || btT('cdx_product.sold_out', 'Derzeit nicht verfügbar');
        atcBtns.forEach(function (b) { b.disabled = true; });
        if (atcLabel) atcLabel.textContent = btT('cdx_product.unavailable', 'Nicht verfügbar');
        buyNowBtns.forEach(function (b) { b.disabled = true; });
      }
      if (dtEl) {
        var dtText = vInfo.time || dtEl.getAttribute('data-delivery-fallback') || '';
        if (dtVal) dtVal.textContent = dtText;
        dtEl.hidden = !dtText;
      }
      // notify theme (variant:changed) for any listeners
      document.documentElement.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: v } }));
    }

    valueBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('unavail') && b.dataset.hardlock === '1') return;
        selected[b.dataset.position] = b.dataset.value;
        render();
        /* Options-Dropdown nach der Wahl schliessen (14.09.2026). */
        var ms = b.closest('[data-model-select]');
        if (ms) {
          ms.classList.remove('open');
          var mt = ms.querySelector('[data-model-toggle]');
          if (mt) mt.setAttribute('aria-expanded', 'false');
        }
      });
    });
    updateDeltas();
    render();

    /* ---------- Quantity (inkl. gespiegeltem Sticky-Stepper) ---------- */
    var qty = root.querySelector('[data-qty]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    var mstickyQval = root.querySelector('[data-msticky-qval]');
    function clampQty() { var n = parseInt(qty.value, 10); if (isNaN(n) || n < 1) n = 1; qty.value = n; return n; }
    function bumpQty(delta) { if (!qty) return; qty.value = Math.max(1, clampQty() + delta); qty.dispatchEvent(new Event('change', { bubbles: true })); }
    if (qty) qty.addEventListener('change', function () { clampQty(); if (mstickyQval) mstickyQval.textContent = qty.value; });
    if (minus) minus.addEventListener('click', function () { bumpQty(-1); });
    if (plus) plus.addEventListener('click', function () { bumpQty(1); });
    root.querySelectorAll('[data-msticky-qminus]').forEach(function (b) { b.addEventListener('click', function () { bumpQty(-1); }); });
    root.querySelectorAll('[data-msticky-qplus]').forEach(function (b) { b.addEventListener('click', function () { bumpQty(1); }); });

    /* ---------- Zubehör + AVIS-Konfiguration (Buybox-Summe) ---------- */
    var accSelected = {}; // variantId -> { price, title, qty }
    var openAccEdit = null; // wird vom Zubehoer-Editor-Modal gesetzt
    var totalEl = root.querySelector('[data-total]');       // Held-Preis = Gesamt
    var priceBrk = root.querySelector('[data-price-brk]');   // Aufschluesselungs-Box
    var brkBase = root.querySelector('[data-base]');         // Grundpreis-Zeile
    var brkList = root.querySelector('[data-brk-list]');     // Konfig/Zubehoer-Zeilen
    var mstickyTotal = root.querySelector('[data-msticky-total]');
    var mstickyLabel = root.querySelector('[data-msticky-label]');
    var buyPanel = root.querySelector('.buy-panel');
    // Fallback-Grundpreis aus dem initial gerenderten Held-Preis (fuer Demo ohne echte Variante)
    var initialBase = 0;
    function esc(s) { return String(s == null ? '' : s).replace(/[<>&"]/g, function (c) { return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]; }); }
    var avisModal = root.querySelector('[data-avis-modal]');
    var avisAnchor = avisModal && avisModal.querySelector('[data-avis-anchor]');
    function accSum() { var s = 0; Object.keys(accSelected).forEach(function (id) { var a = accSelected[id]; s += a.price * (a.qty || 1); }); return s; }
    function mainPrice() { var v = matchVariant(); return v ? v.price : 0; }
    // Betrag aus Text in Cents parsen (24,00 / 1.234,56 / 24.00)
    function parseMoney(str) {
      var m = (str || '').replace(/[^\d.,]/g, ' ').match(/\d[\d.,]*/g);
      if (!m) return 0;
      var raw = m.sort(function (a, b) { return b.length - a.length; })[0];
      if (/,\d{2}$/.test(raw)) raw = raw.replace(/\./g, '').replace(',', '.');
      else if (/\.\d{2}$/.test(raw)) raw = raw.replace(/,/g, '');
      else raw = raw.replace(/[.,]/g, '');
      var f = parseFloat(raw);
      return isNaN(f) ? 0 : Math.round(f * 100);
    }
    /* AVIS-Aufpreis lesen. Quellen in dieser Reihenfolge:
       1. Selektor aus den Section-Einstellungen (avis_price_selector),
       2. die App-eigene Aufpreis-Summe (#avp-productoption-total-add / .apo-total-addcharge),
       3. Summe der Preise an den aktuell gewaehlten Optionswerten.
       Findet keine Quelle etwas, ist der Aufpreis 0. Frueher wurde als letzter Ausweg
       der komplette Anker-Text nach der ersten Zahl durchsucht — das griff sich
       RAL-Nummern, Mengen oder Massangaben und ergab einen konstanten Fantasiebetrag,
       waehrend der echte Aufpreis (z. B. Lackierung) nie in die Summe kam. */
    /* Die App-Summe steht in einem versteckten <input class="apo-total-addcharge">
       als Zahl in Euro ("1799.85") — nicht als formatierter Text. */
    var AVIS_TOTAL_SEL = '#avp-productoption-total-add, .avp-productoption-total-add, .apo-total-addcharge';
    function avisText(el) { return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim(); }
    /* WUNSCHFARBE: EINE FARBE, NICHT ZWEI
       Der Farbwaehler ist in AVIS eine eigene Optionsgruppe. Fuer den Kunden ist
       er aber nur ein weiterer Wert der Farbauswahl — entweder eine der festen
       Farben oder eine eigene. Er sitzt deshalb als Kachel in derselben Reihe
       (siehe cfgColorTile) und darf nie gleichzeitig mit einer festen Farbe
       gelten: AVIS berechnet sonst zweimal denselben Lackieraufpreis, und in der
       Bestellung stuenden zwei Farben.

       Ein `input[type=color]` hat IMMER einen Wert — ohne Zutun #000000. Die App
       fuehrt die Wunschfarbe deshalb von Anfang an in ihren Properties und in
       ihrer Aufpreis-Summe mit, obwohl der Kunde nichts gewaehlt hat. Was
       gewaehlt ist, entscheidet darum dieser Merker und nicht das Feld. Er haengt
       an keinem Knoten und uebersteht damit das Neu-Rendern der App.
         group/tile/ziel  die jeweils aktuellen Knoten (die App baut sie neu)
         key/fixKey       Gruppentitel = Name der Line-Item-Property
         on               Wunschfarbe gilt
         ral              gewaehlter RAL-Ton { code, name, hex } oder null
         prev             feste Farbe, die vor der Wunschfarbe galt */
    var wf = { group: null, tile: null, ziel: null, key: '', fixKey: '', on: false, ral: null, prev: '', vorher: '', reset: false };
    /* Welche Gruppe faellt gerade heraus: ohne Wunschfarbe der Farbwaehler, mit
       Wunschfarbe die feste Farbe. Gilt fuer Anzeige, Preis und Warenkorb. */
    function wfSkip(key) {
      if (!key) return false;
      if (wf.key && key === wf.key) return !wf.on;
      if (wf.fixKey && key === wf.fixKey) return wf.on;
      return false;
    }
    /* Was nicht gilt, faehrt auch nicht mit. Die Line-Item-Properties baut die
       PDP selbst (addToCart), deshalb wird hier bereinigt:
         - die Property der nicht geltenden Farbe faellt weg,
         - AVIS fuehrt seine Auswahl zusaetzlich als JSON in `_apo_options` mit,
           inklusive Aufpreis-Summe `_apo_addons` — dort muss dieselbe Position
           raus, sonst steht sie in der Bestellung und ihr Aufpreis wird weiter
           mitgefuehrt.
       Die feste Farbe braucht das nicht: sie wird beim Umschalten wirklich
       abgewaehlt, und darauf raeumt die App selbst auf. */
    function wfCleanProps(props) {
      if (!wf.group || !wf.key) return;
      /* Mit Wunschfarbe faellt die feste Farbe weg, ohne sie der Farbwaehler.
         Die feste Farbe bleibt dabei im Formular auf der Standardfarbe stehen:
         die Farbauswahl ist eine Pflichtgruppe, und AVIS laesst seinen eigenen
         Warenkorb-Button nicht los, solange sie leer ist. Aus der Bestellung
         gehoert sie trotzdem heraus — gefahren wird die Wunschfarbe. */
      var weg = wf.on ? wf.fixKey : wf.key;
      /* Hat der Kunde einen RAL-Ton gewaehlt, faehrt die RAL-Nummer mit und nicht
         nur der Hexwert: bestellt und lackiert wird nach RAL. Der Hexwert bleibt
         in Klammern dabei, damit im Auftrag steht, was der Kunde gesehen hat. */
      var neu = (wf.on && wf.ral) ? ('RAL ' + wf.ral.code + ' ' + wf.ral.name + ' (' + wf.ral.hex + ')') : '';
      var abzug = 0;
      if (weg && props.hasOwnProperty(weg)) {
        delete props[weg];
        if (wf.on) {
          var gewaehlt = wf.ziel && wf.ziel.querySelector('input[type="radio"]:checked');
          if (gewaehlt && !gewaehlt.closest('.cfg-wf')) abzug = avisValuePrice(gewaehlt.closest('label'));
        } else {
          var pill = wf.group.querySelector('.apo-title-addcharge');
          abzug = pill ? parseMoney(pill.textContent) : 0;
        }
      } else weg = '';
      if (neu && props.hasOwnProperty(wf.key)) props[wf.key] = neu;
      var raw = props['_apo_options'];
      if (!raw || (!weg && !neu)) return;
      // Fremdes JSON — ein Formatwechsel der App darf den Warenkorb nicht sprengen
      try {
        var liste = JSON.parse(raw);
        if (!liste || !liste.length) return;
        var out = [];
        liste.forEach(function (e) {
          if (!e) return;
          if (weg && e.name === weg) return;
          if (neu && e.name === wf.key) { out.push({ name: e.name, value: neu }); return; }
          if (e.name === '_apo_addons' && abzug) {
            var rest = Math.max(0, Math.round(parseFloat(e.value) * 100) - abzug);
            out.push({ name: e.name, value: (rest / 100).toFixed(2) });
            return;
          }
          out.push(e);
        });
        props['_apo_options'] = JSON.stringify(out);
      } catch (e) {}
    }
    /* Optionsgruppen der App. Der Container der versteckten Felder und
       verschachtelte Gruppen gehoeren nicht in die Liste. */
    function avisGroups() {
      var out = [];
      if (!avisModal) return out;
      avisModal.querySelectorAll('.avp-option').forEach(function (g) {
        if (g.classList.contains('ap-options__hidden-field-container')) return;
        /* Verschachtelte Gruppen (Option Group der App) nicht doppelt listen.
           Ausnahme: die als Kachel in die Farbauswahl einsortierte Wunschfarbe
           (siehe cfgColorTile) liegt zwar in einer anderen Gruppe, bleibt aber
           eine eigene Option — sonst faellt ihr Aufpreis aus der
           Aufschluesselung und landet unzugeordnet im Grundpreis. */
        if (g.parentElement && g.parentElement.closest('.avp-option') && !g.classList.contains('cfg-wf')) return;
        // Die gerade nicht geltende Farbe zaehlt nirgends mit (siehe wfSkip)
        if (wfSkip(avisGroupLabel(g))) return;
        out.push(g);
      });
      return out;
    }
    /* Gruppentitel ohne Beiwerk: die App haengt den Aufpreis der Gruppe als
       `.apo-title-addcharge` direkt an den Titel („RAL-Farbe(+1.799,85 €)") und
       daneben das Hilfe-Icon. Beides gehoert nicht in den Namen der Position. */
    function avisGroupLabel(g) {
      var l = g.querySelector('.ap-label-tooltip label') || g.querySelector('.ap-label-tooltip');
      if (!l) return '';
      var c = l.cloneNode(true);
      c.querySelectorAll('.apo-title-addcharge, .ap-tooltip').forEach(function (x) { x.parentNode.removeChild(x); });
      return avisText(c).replace(/\s*\(\s*\+[^)]*\)\s*$/, '').replace(/\s*\*$/, '').trim();
    }
    /* Preis eines Optionswerts. Der Streichpreis (.apo-compare-price) steckt im
       selben Knoten und waere die groessere Zahl — er muss vorher raus. */
    function avisValuePrice(lbl) {
      if (!lbl) return 0;
      var q = lbl.querySelector('.avp-quantity-input');
      var mult = q ? (parseInt(q.value, 10) || 1) : 1;
      var m = lbl.querySelector('.apo-money, .money');
      if (m) {
        var c = m.cloneNode(true);
        c.querySelectorAll('.apo-compare-price').forEach(function (x) { x.parentNode.removeChild(x); });
        return parseMoney(c.textContent) * mult;
      }
      /* Variantengebundene Werte („Gebuendeltes Produkt") tragen ihren Aufpreis
         nur als Datenattribut in Cent — dafuer rendert die App kein sichtbares
         Preiselement. Siehe cfgValuePrices(), das die Kachel nachtraeglich
         beschriftet. */
      var inp = lbl.querySelector('input[data-variant-price]');
      return inp ? Math.round(parseFloat(inp.getAttribute('data-variant-price')) || 0) * mult : 0;
    }
    /* Titel eines Optionswerts ohne Preis: die App haengt ihre Preispille in
       denselben Knoten wie den Namen ("Salbeigruen (RAL 6021)+€ 527,85"), in der
       Aufschluesselung steht der Betrag aber ohnehin als eigene Spalte — sonst
       stuende er zweimal in der Zeile. */
    function avisValueTitle(el) {
      if (!el) return '';
      var c = el.cloneNode(true);
      c.querySelectorAll('.apo-money, .money').forEach(function (x) { x.parentNode.removeChild(x); });
      return avisText(c);
    }
    /* Notloesung, wenn eine Wert-Kachel kein eigenes Titelelement hat: der Text
       der ganzen Kachel, aber ohne Preis, Hilfetext und Tooltip — sonst stuende
       der Aufpreis doppelt in der Zeile (einmal als Text, einmal als Betrag). */
    function avisValueText(lbl) {
      if (!lbl) return '';
      var c = lbl.cloneNode(true);
      c.querySelectorAll('.apo-money, .money, .apo-value-help-text, .option-value-des, .apo-swatch-tooltip, .ap-tooltip').forEach(function (x) { x.parentNode.removeChild(x); });
      return avisText(c);
    }
    /* Gewaehlte Werte einer Gruppe: Radio/Checkbox ueber den sichtbaren Werttitel,
       Dropdown ueber den Text der Option, Frei-/Zahlenfelder ueber ihren Inhalt.
       Bei Dropdowns und Freifeldern haengt der Aufpreis im Text der App — den
       liefert die App-Summe zuverlaessiger als eine Regex, daher p = 0. */
    function avisGroupValues(g) {
      var vals = [], seen = {};
      /* Die als Kachel in die Farbauswahl einsortierte Wunschfarbe liegt im DOM
         in dieser Gruppe, ist aber eine eigene: ihre Felder gehoeren nicht in
         die Werte der Farbauswahl — sonst stuende in der Aufschluesselung
         „Standardfarbe, #000000" in einer Zeile. Das gilt genauso fuer die
         Felder, die wir selbst in die Kachel bauen (RAL-Suche): sie tragen keinen
         Optionswert, sondern bedienen nur den Farbwaehler. */
      var fremd = function (el) { var w = el.closest('.cfg-wf, .cfg-wf-tile'); return !!w && w !== g; };
      /* Mit RAL-Ton steht in der Aufschluesselung die RAL-Nummer und nicht der
         Hexwert: lackiert wird nach RAL, die Bildschirmfarbe ist nur Vorschau. */
      if (g === wf.group && wf.on && wf.ral) return [{ v: 'RAL ' + wf.ral.code + ' ' + wf.ral.name, p: 0 }];
      function add(v, p) {
        v = String(v == null ? '' : v).replace(/\s+/g, ' ').trim();
        if (!v || seen[v]) return;
        seen[v] = 1;
        vals.push({ v: v, p: p || 0 });
      }
      g.querySelectorAll('input:checked').forEach(function (inp) {
        if (fremd(inp)) return;
        var lbl = inp.closest('label');
        var t = lbl && lbl.querySelector('.apo-value-title, .swatch-variant-title, .choice-list-variatnt-title');
        add(avisValueTitle(t) || avisValueText(lbl) || inp.value, avisValuePrice(lbl));
      });
      g.querySelectorAll('select').forEach(function (sel) {
        if (fremd(sel)) return;
        add(avisText(sel.options[sel.selectedIndex]) || sel.value, 0);
      });
      /* Freifelder inklusive Color-Picker: die App legt ueber das sichtbare
         Hex-Feld ein unsichtbares <input type="color"> (.apo-color-image). Beide
         tragen denselben Wert, deshalb wird dedupliziert (siehe add()). */
      g.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="date"], input[type="color"], textarea').forEach(function (el) {
        /* Mengenfelder: sitzt das Feld in einem Label, gehoert es zu einem
           Optionswert und ist nur dessen Stueckzahl. Steht es allein in der
           Gruppe (ap-options__quantity-container), IST die Menge der Wert. */
        if (fremd(el)) return;
        var isQty = el.type === 'number' || el.classList.contains('avp-quantity-input');
        if (isQty && el.closest('label')) return;
        if (isQty) {
          var n = parseFloat(el.value);
          if (!n) return;                                 // 0 oder leer = nicht gewaehlt
          add(n + '×', 0);
          return;
        }
        add(el.value, 0);
      });
      return vals;
    }
    function avisSelectedSum() {
      var sum = 0;
      avisGroups().forEach(function (g) { avisGroupValues(g).forEach(function (x) { sum += x.p; }); });
      return sum;
    }
    /* Betrag aus einem App-Element: das versteckte Input fuehrt die Summe als
       Ganzzahl in Cent, die Textvariante als Fliesstext („Selection will add
       €29,00 to the price"). */
    function avisElAmount(el) {
      if (!el) return 0;
      return el.tagName === 'INPUT' ? Math.round(parseFloat(el.value) || 0) : parseMoney(el.textContent);
    }
    function avisAddon() {
      if (!avisModal) return 0;
      var sel = avisModal.getAttribute('data-avis-price-selector');
      var t = 0;
      if (sel) {
        // Der Selektor kommt aus einem Freitextfeld — ein Tippfehler darf die Summe nicht sprengen
        try { t = avisElAmount(avisModal.querySelector(sel)); } catch (e) { t = 0; }
      }
      /* Ohne eigenen Selektor zuerst das Input: es ist sprachunabhaengig, waehrend
         der sichtbare Text je nach App-Sprache anders aufgebaut ist. Eine
         Selektorliste taugt dafuer nicht — querySelector nimmt das erste Element
         in Dokumentreihenfolge, nicht das erste passende Muster. */
      if (!t) t = avisElAmount(avisModal.querySelector('input.apo-total-addcharge'));
      if (!t) t = avisElAmount(avisModal.querySelector(AVIS_TOTAL_SEL));
      // Meldet die App nichts (noch nicht gerendert), selbst zusammenzaehlen
      return t > 0 ? t : avisSelectedSum();
    }
    /* Kostet schon die Standardkonfiguration etwas — vorbelegte Optionswerte mit
       Aufpreis, etwa eine RAL-Farbe, die AVIS mit einem Wert startet —, gehoert
       dieser Betrag zum Grundpreis. Als „Konfiguration" zaehlt nur, was der Kunde
       selbst dazulegt. Der Basisbetrag wird immer dann neu genommen, wenn nichts
       vom Default abweicht (siehe renderBundle), damit er auch stimmt, wenn AVIS
       seine Summe erst nach dem Snapshot nachtraegt oder zurueckgesetzt wird. */
    var avisBaseAddon = 0;
    /* Aufpreis der Konfiguration = Summe der abweichenden Positionen. Die
       App-Summe taugt dafuer allein nicht: fuehrt sie den Betrag schon fuer den
       vorbelegten Wert, steigt sie beim Aendern nicht an und die Differenz waere
       null. Umgekehrt kennt sie Aufpreise, die an keiner Position ablesbar sind
       (Dropdowns). Deshalb der groessere der beiden Werte. */
    function avisConfigAddon() {
      var sum = 0;
      avisChips().forEach(function (c) { sum += c.p; });
      return Math.max(0, sum, avisAddon() - avisBaseAddon);
    }
    function avisLabel(key, value) {
      var low = String(value).toLowerCase();
      return (low === 'on' || low === 'yes' || low === 'true' || low === '1') ? key : value;
    }
    /* Aktueller Zustand als Gruppentitel -> gewaehlter Wert. Quelle ist das
       gerenderte AVIS-Markup, also genau das, was der Kunde im Modal sieht.
       Rendert AVIS nichts (Embed/Demo), greifen die Line-Item-Properties im
       Formular als Fallback. */
    function avisState() {
      var map = {}, n = 0;
      avisGroups().forEach(function (g) {
        var key = avisGroupLabel(g);
        if (!key) return;
        var vals = avisGroupValues(g);
        if (!vals.length) return;
        map[key] = vals.map(function (x) { return x.v; }).join(', ');
        n++;
      });
      if (n || !form) return map;
      form.querySelectorAll('[name^="properties["]').forEach(function (el) {
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        if (!el.value || el.disabled) return;
        var m = el.name.match(/^properties\[(.+)\]$/);
        if (!m) return;
        var key = m[1];
        if (key.charAt(0) === '_') return; // versteckte Properties (beginnen mit _)
        map[key] = avisLabel(key, el.value);
      });
      return map;
    }
    /* Aufpreis einer einzelnen Gruppe — fuer die Zeilen der Aufschluesselung.
       Zuerst die Preise an den gewaehlten Werten. Gruppen ohne Wertpreise
       (Freifeld, Color-Picker, Dropdown) tragen ihren Aufpreis stattdessen am
       Gruppentitel: `.apo-title-addcharge`, im Modal als „RAL-Farbe(+1.799,85 €)"
       sichtbar. */
    function avisPriceFor(key) {
      var sum = 0, title = 0;
      avisGroups().forEach(function (g) {
        if (avisGroupLabel(g) !== key) return;
        avisGroupValues(g).forEach(function (x) { sum += x.p; });
        var t = g.querySelector('.apo-title-addcharge');
        if (t) title += parseMoney(t.textContent);
      });
      return sum || title;
    }
    /* Startzustand von AVIS = Default-Konfiguration. Wird einmal festgehalten,
       sobald AVIS gerendert hat (siehe avisSnapshot). Solange kein Snapshot
       existiert, gilt nichts als gewaehlt – sonst wuerden die Defaults selbst
       als Auswahl zaehlen und Buybox und Aufschluesselung faelschlich fuellen. */
    var avisDefaults = null;
    var avisDefaultFields = null;
    /* Zusaetzlich zum Anzeige-Zustand der Feldzustand: Radio/Checkbox ueber
       name=value, alle uebrigen Felder ueber ihren Wert. Nur damit laesst sich
       spaeter auf die Standardkonfiguration zurueckstellen — die Anzeige-Labels
       allein reichen dafuer nicht. */
    function avisFieldState() {
      var st = { checked: {}, values: {} };
      if (!avisModal) return st;
      avisModal.querySelectorAll('input, select, textarea').forEach(function (el) {
        if (!el.name) return;
        if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) st.checked[el.name + '=' + el.value] = 1; }
        else st.values[el.name] = el.value;
      });
      return st;
    }
    function avisSnapshot() {
      if (avisDefaults) return;
      var cur = avisState();
      for (var k in cur) {
        if (cur.hasOwnProperty(k)) { avisDefaults = cur; avisDefaultFields = avisFieldState(); return; }
      }
    }
    /* Zurueck auf die Standardkonfiguration. Felder, die im Snapshot keinen Wert
       hatten, werden geleert — so verschwindet auch eine eingetragene RAL-Farbe.
       AVIS rendert bei jeder Aenderung neu, deshalb erst die Liste einsammeln und
       vor dem Schreiben pruefen, ob das Feld noch im Dokument haengt. */
    function avisResetToDefaults() {
      if (!avisModal || !avisDefaultFields) return;
      /* Ob eine Wunschfarbe gilt, haengt nicht am Feld, sondern am Merker — beim
         Zuruecksetzen gilt sie nicht mehr. Solange hier Felder gesetzt werden,
         halten sich die eigenen Handler heraus: das ist keine Wahl des Kunden. */
      wf.reset = true;
      wf.on = false;
      wf.ral = null;
      wf.prev = '';
      var els = Array.prototype.slice.call(avisModal.querySelectorAll('input, select, textarea'));
      els.forEach(function (el) {
        if (!el.name || !document.contains(el)) return;
        var changed = false;
        if (el.type === 'radio' || el.type === 'checkbox') {
          var want = !!avisDefaultFields.checked[el.name + '=' + el.value];
          if (el.checked !== want) { el.checked = want; changed = true; }
        } else {
          var val = avisDefaultFields.values.hasOwnProperty(el.name) ? avisDefaultFields.values[el.name] : '';
          if (el.value !== val) { el.value = val; changed = true; }
        }
        if (!changed) return;
        // AVIS haengt an input/change — beide feuern, damit Aufpreis und Logik nachziehen
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
      wf.reset = false;
      if (wf.sync) wf.sync();
      renderBundle();
    }
    /* Nur Abweichungen vom Default gelten als getroffene Auswahl.
       Ergebnis je Position: { k: Gruppentitel, v: Wert, p: Aufpreis in Cent }. */
    function avisChips() {
      if (!avisDefaults) return [];
      var cur = avisState(), out = [], k;
      for (k in cur) {
        if (cur.hasOwnProperty(k) && avisDefaults[k] !== cur[k]) out.push({ k: k, v: cur[k], p: avisPriceFor(k) });
      }
      for (k in avisDefaults) {
        /* Die abgewaehlte feste Farbe ist keine Position „ohne" — an ihrer
           Stelle steht die Wunschfarbe. */
        if (avisDefaults.hasOwnProperty(k) && !cur.hasOwnProperty(k) && !wfSkip(k)) out.push({ k: k, v: btT('cdx_product.without', 'ohne'), p: 0 });
      }
      return out;
    }
    function renderBundle() {
      var ids = Object.keys(accSelected);
      var chips = avisChips();
      var addon = avisAddon();
      var hasConfig = chips.length > 0;                  // nur echte Abweichungen vom Default
      var hasAcc = ids.length > 0;                       // Zubehör: separate Produkte
      var show = hasConfig || hasAcc;
      var mq = qty ? (parseInt(qty.value, 10) || 1) : 1;
      var base = mainPrice() || initialBase;             // Demo ohne Variante: Fallback-Grundpreis
      /* Steht der Konfigurator auf Standard, zaehlt der Aufpreis der App nicht:
         AVIS weist ihn auch fuer vorbelegte Werte aus (z. B. eine RAL-Farbe, die
         mit einem Hex-Wert startet), obwohl der Kunde nichts gewaehlt hat. Erst
         die Abweichung vom Startzustand geht in den Preis ein. Der Basisbetrag
         wird laufend nachgezogen, solange nichts abweicht — damit stimmt er auch,
         wenn AVIS seine Summe spaeter nachtraegt oder zurueckgesetzt wird. */
      if (!hasConfig) avisBaseAddon = addon;
      var chipSum = 0;
      chips.forEach(function (c) { chipSum += c.p; });
      var cfgAddon = Math.max(0, chipSum, addon - avisBaseAddon);
      var grand = base * mq + accSum() + cfgAddon;
      /* Aufpreis, den keine Zeile ausweist (Dropdown ohne ablesbaren Preis):
         eindeutig zuordenbar, wenn genau eine Position ohne Preis dasteht. */
      var open = chips.filter(function (c) { return !c.p; });
      if (open.length === 1 && cfgAddon > chipSum) { open[0].p = cfgAddon - chipSum; chipSum = cfgAddon; }
      /* Alles, was die Zeilen nicht ausweisen, bleibt im Grundpreis — sonst
         stuenden Summe und Aufschluesselung auseinander. */
      var baseShown = base * mq + Math.max(0, cfgAddon - chipSum);
      // Held-Zahl = Gesamtpreis (Variante A)
      if (totalEl && base > 0) totalEl.textContent = money(grand);
      if (mstickyTotal) mstickyTotal.textContent = money(grand);
      if (mstickyLabel) mstickyLabel.textContent = btT('cdx_product.total_price', 'Gesamtpreis');
      // Aufschluesselung nur bei Konfiguration/Zubehoer
      if (priceBrk) priceBrk.hidden = !show;
      if (buyPanel) buyPanel.classList.toggle('has-config', show);
      if (brkBase) brkBase.textContent = money(baseShown);
      if (brkList) {
        var rows = '';
        // Eine Zeile je gewaehlter AVIS-Position — nicht alles in eine Zeile quetschen
        chips.forEach(function (c) {
          rows += '<button type="button" class="brk-row brk-cfg" data-avis-open-row aria-label="' + esc(btT('cdx_product.edit_configuration', 'Konfiguration anpassen')) + '"><span class="k">' + esc(c.k ? c.k + ': ' + c.v : c.v) + '</span><span class="v">' + (c.p > 0 ? '+ ' + money(c.p) : esc(btT('cdx_product.included', 'inkl.'))) + '<svg class="cdx-ic brk-edit-ic"><use href="#ui-edit"/></svg></span></button>';
        });
        ids.forEach(function (id) {
          var a = accSelected[id];
          var q = a.qty || 1;
          rows += '<button type="button" class="brk-row brk-acc" data-acc-edit="' + id + '" aria-label="' + esc(btT('cdx_product.edit_accessory', 'Zubehör anpassen')) + '"><span class="k">' + (q > 1 ? q + '× ' : '') + esc(a.title) + '</span><span class="v">+ ' + money(a.price * q) + '<svg class="cdx-ic brk-edit-ic"><use href="#ui-edit"/></svg></span></button>';
        });
        brkList.innerHTML = rows;
      }
      // „Weiter konfigurieren"-Button: Active-State (gelb) + Options-Counter
      root.querySelectorAll('[data-avis-open]').forEach(function (b) {
        b.classList.toggle('is-active', hasConfig);
        var c = b.querySelector('[data-avis-count]');
        if (c) {
          if (chips.length) { c.textContent = chips.length; c.hidden = false; }
          else { c.hidden = true; }
        }
      });
      // Options-Kachel in der Zubehoer-Section: dieselbe Zahl wie am Buybox-Knopf
      document.querySelectorAll('[data-avis-open-ext]').forEach(function (t) {
        t.classList.toggle('is-active', hasConfig);
        var st = t.querySelector('[data-avis-ext-state]');
        if (st) st.textContent = chips.length ? (chips.length === 1 ? btT('cdx_product.options_selected_one', '1 Option gewählt') : btT('cdx_product.options_selected_other', '{n} Optionen gewählt', { n: chips.length })) : (st.getAttribute('data-default') || '');
      });
      // „Zurücksetzen" nur, wenn es etwas zurueckzusetzen gibt
      root.querySelectorAll('[data-avis-reset]').forEach(function (b) { b.hidden = !hasConfig; });
    }
    function toggleAcc(btn) {
      var id = btn.dataset.accId;
      if (!id) return;
      if (accSelected[id]) { delete accSelected[id]; btn.classList.remove('is-added'); }
      else { accSelected[id] = { price: Number(btn.dataset.accPrice) || 0, title: btn.dataset.accTitle || btT('cdx_product.accessories', 'Zubehör'), qty: 1 }; btn.classList.add('is-added'); }
      renderBundle();
    }
    // Delegation ueber das ganze Dokument: Teaser (diese Section) + BTF-Zubehoer-Sektion
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add-accessory]');
      if (add) { e.preventDefault(); toggleAcc(add); return; }
      // Konfigurationszeile in der Aufschluesselung -> Konfigurations-Modal oeffnen
      var cfg = e.target.closest('[data-avis-open-row]');
      if (cfg) {
        e.preventDefault();
        var opener = root.querySelector('[data-avis-open]');
        if (opener) opener.click();
        return;
      }
      // Konfiguration auf den AVIS-Standard zuruecksetzen
      var rst = e.target.closest('[data-avis-reset]');
      if (rst) { e.preventDefault(); avisResetToDefaults(); return; }
      var edit = e.target.closest('[data-acc-edit]');
      if (edit) { e.preventDefault(); if (openAccEdit) openAccEdit(edit.getAttribute('data-acc-edit')); return; }
      var rm = e.target.closest('[data-acc-remove]');
      if (rm) { e.preventDefault(); var id = rm.getAttribute('data-acc-remove'); delete accSelected[id]; var src = document.querySelector('[data-add-accessory][data-acc-id="' + id + '"]'); if (src) src.classList.remove('is-added'); renderBundle(); }
    });
    document.addEventListener('variant:changed', renderBundle);
    if (qty) qty.addEventListener('change', renderBundle);
    // AVIS-Optionen liegen im Produktformular -> jede Aenderung aktualisiert die Summe
    if (form) { form.addEventListener('change', renderBundle); form.addEventListener('input', renderBundle); }
    /* AVIS rendert asynchron und nach. Der Default-Snapshot wird deshalb erst
       genommen, wenn das Markup kurz zur Ruhe gekommen ist – vorher stuende nur
       die halbe Optionsliste drin und der Rest zaehlte spaeter als Auswahl. */
    if (form && window.MutationObserver) {
      var snapTimer = null;
      var snapObserver = new MutationObserver(function () {
        clearTimeout(snapTimer);
        snapTimer = setTimeout(function () {
          avisSnapshot();
          if (avisDefaults && snapObserver) { snapObserver.disconnect(); snapObserver = null; }
          renderBundle();
        }, 400);
      });
      snapObserver.observe(form, { childList: true, subtree: true });
    }
    /* Der Observer feuert nur, wenn AVIS NACH dem Theme rendert. War die App
       schon fertig (Cache, Back-Navigation), gaebe es nie eine Mutation und damit
       nie einen Snapshot – dann blieben Aufschluesselung und Aktiv-Status des
       Buttons dauerhaft leer. Deshalb zusaetzlich pollen, bis Optionen da sind. */
    var snapTries = 0;
    var snapPoll = setInterval(function () {
      avisSnapshot();
      if (avisDefaults || ++snapTries > 40) {   // max. 10 s
        clearInterval(snapPoll);
        if (avisDefaults) renderBundle();
      }
    }, 250);
    if (avisAnchor && window.MutationObserver) { new MutationObserver(renderBundle).observe(avisAnchor, { childList: true, subtree: true, characterData: true }); }
    initialBase = parseMoney(totalEl ? totalEl.textContent : ''); // Grundpreis-Fallback aus Initial-Render
    renderBundle(); // Initialsumme (u.a. mobiler Sticky-ATC) setzen

    /* ---------- Zubehör-Editor-Modal (Menge ändern / entfernen) ---------- */
    var accEditModal = root.querySelector('[data-acc-edit-modal]');
    if (accEditModal) {
      var editingAccId = null;
      var aeTitle = accEditModal.querySelector('[data-ae-title]');
      var aeEach = accEditModal.querySelector('[data-ae-each]');
      var aeQtyEl = accEditModal.querySelector('[data-ae-qty]');
      var aeTotalEl = accEditModal.querySelector('[data-ae-total]');
      var lockAcc = function (on) { document.documentElement.style.overflow = on ? 'hidden' : ''; document.body.style.overflow = on ? 'hidden' : ''; };
      var aeSync = function () {
        var a = accSelected[editingAccId]; if (!a) return;
        var q = a.qty || 1;
        if (aeTitle) aeTitle.textContent = a.title;
        if (aeEach) aeEach.textContent = btT('cdx_product.per_piece', '{amount} / Stück', { amount: money(a.price) });
        if (aeQtyEl) aeQtyEl.value = q;
        if (aeTotalEl) aeTotalEl.textContent = money(a.price * q);
      };
      var aeSetQty = function (n) { var a = accSelected[editingAccId]; if (!a) return; a.qty = Math.max(1, n || 1); aeSync(); renderBundle(); };
      var closeAccEdit = function () { accEditModal.hidden = true; lockAcc(false); editingAccId = null; };
      openAccEdit = function (id) { if (!accSelected[id]) return; editingAccId = id; aeSync(); accEditModal.hidden = false; lockAcc(true); };
      accEditModal.querySelectorAll('[data-acc-edit-close]').forEach(function (b) { b.addEventListener('click', closeAccEdit); });
      var aeMinus = accEditModal.querySelector('[data-ae-minus]');
      var aePlus = accEditModal.querySelector('[data-ae-plus]');
      if (aeMinus) aeMinus.addEventListener('click', function () { var a = accSelected[editingAccId]; aeSetQty((a && a.qty || 1) - 1); });
      if (aePlus) aePlus.addEventListener('click', function () { var a = accSelected[editingAccId]; aeSetQty((a && a.qty || 1) + 1); });
      if (aeQtyEl) aeQtyEl.addEventListener('change', function () { aeSetQty(parseInt(aeQtyEl.value, 10) || 1); });
      var aeRemove = accEditModal.querySelector('[data-ae-remove]');
      if (aeRemove) aeRemove.addEventListener('click', function () {
        var id = editingAccId;
        if (id) { delete accSelected[id]; var src = document.querySelector('[data-add-accessory][data-acc-id="' + id + '"]'); if (src) src.classList.remove('is-added'); renderBundle(); }
        closeAccEdit();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !accEditModal.hidden) closeAccEdit(); });
    }

    // Sticky-ATC einblenden, sobald der Preis NICHT im Viewport ist — egal ob darüber
    // (weggescrollt) oder darunter (beim Laden, wenn die Buybox unter dem Fold liegt).
    // Ist der Preis sichtbar, bleibt die Sticky-Bar aus.
    var mstickyBar = root.querySelector('[data-msticky]');
    var mstickyWatch = root.querySelector('[data-total]') || root.querySelector('[data-atc]');
    // Platz fuer die Leiste am Seitenende (Tim, 16.09.2026): die fixe Leiste lag ueber
    // der Fusszeile des Footers (Impressum, Datenschutz ...). Solange sie sichtbar ist,
    // bekommt der Body unten so viel Innenabstand wie die Leiste hoch ist - der Footer
    // scrollt dann ueber die Leiste hinaus, statt darunter zu verschwinden.
    var syncStickyPad = function () {
      if (!mstickyBar) return;
      var sichtbar = mstickyBar.classList.contains('cdx-msticky--show') && !mstickyBar.classList.contains('is-cart-open');
      document.body.style.paddingBottom = sichtbar ? mstickyBar.offsetHeight + 'px' : '';
    };
    if (mstickyBar && mstickyWatch && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        mstickyBar.classList.toggle('cdx-msticky--show', !e.isIntersecting);
        syncStickyPad();
      }, { threshold: 0 }).observe(mstickyWatch);
    } else if (mstickyBar) {
      mstickyBar.classList.add('cdx-msticky--show');
      syncStickyPad();
    }
    if (mstickyBar) window.addEventListener('resize', syncStickyPad);
    // Sticky-Bar ausblenden, solange der Mini-Cart-Drawer offen ist (aria-hidden="false")
    var miniCart = document.getElementById('mini-cart');
    if (mstickyBar && miniCart && window.MutationObserver) {
      var syncCartOpen = function () { mstickyBar.classList.toggle('is-cart-open', miniCart.getAttribute('aria-hidden') === 'false'); syncStickyPad(); };
      new MutationObserver(syncCartOpen).observe(miniCart, { attributes: true, attributeFilter: ['aria-hidden'] });
      syncCartOpen();
    }

    /* ---------- Add to cart ---------- */
    var atcResetTimer = null;
    var atcButtons = root.querySelectorAll('[data-atc], [data-atc-sticky]');
    // Feedback-Status auf ALLE ATC-Buttons (Haupt + Sticky) anwenden
    function setAtc(state) {
      atcButtons.forEach(function (b) {
        var use = b.querySelector('.cdx-ic use');
        var lbl = b.querySelector('[data-atc-label]') || b.querySelector('span');
        b.classList.remove('is-loading', 'is-success');
        if (state === 'loading') { b.classList.add('is-loading'); return; }
        if (state === 'success') {
          b.classList.add('is-success');
          if (use) use.setAttribute('href', '#ui-check');
          if (lbl) lbl.textContent = btT('cdx_product.added', 'Hinzugefügt');
          return;
        }
        if (use) use.setAttribute('href', '#ui-cart');   // reset
        if (lbl) lbl.textContent = btT('cdx_product.add_to_cart', 'In den Warenkorb');
      });
    }
    function addToCart(silentSuccess) {
      var id = idInput ? idInput.value : root.dataset.currentVariant;
      var quantity = qty ? clampQty() : 1;
      // Line-Item-Properties aus dem Formular sammeln (hier rendert AVIS seine Optionen)
      var mainItem = { id: Number(id), quantity: quantity };
      var props = {};
      if (form) {
        form.querySelectorAll('[name^="properties["]').forEach(function (el) {
          if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
          if (el.disabled || el.name === 'properties[]') return;
          var m = el.name.match(/^properties\[(.+)\]$/);
          if (m) props[m[1]] = el.value;
        });
      }
      wfCleanProps(props);
      if (Object.keys(props).length) mainItem.properties = props;
      var items = [mainItem];
      Object.keys(accSelected).forEach(function (aid) { items.push({ id: Number(aid), quantity: accSelected[aid].qty || 1 }); });
      clearTimeout(atcResetTimer); setAtc('loading');
      return fetch(root.dataset.cartUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: quantity } }));
        // Zubehoer-Auswahl nach erfolgreichem Hinzufuegen zuruecksetzen
        Object.keys(accSelected).forEach(function (aid) { delete accSelected[aid]; var b = document.querySelector('[data-add-accessory][data-acc-id="' + aid + '"]'); if (b) b.classList.remove('is-added'); });
        renderBundle();
        // Visuelles Feedback: Spinner -> gruener Haken „Hinzugefuegt" auf allen ATC-Buttons
        if (!silentSuccess) {
          setAtc('success');
          atcResetTimer = setTimeout(function () { setAtc('reset'); }, 1700);
        } else { atcButtons.forEach(function (b) { b.classList.remove('is-loading'); }); }
        return true;
      }).catch(function (err) {
        console.error('[cdx-pdp] add to cart failed', err);
        atcButtons.forEach(function (b) { b.classList.remove('is-loading'); });
        alert((err && err.description) || btT('cdx_product.cart_error', 'Konnte nicht in den Warenkorb gelegt werden.'));
        return false;
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    }
    root.querySelectorAll('[data-buy-now]').forEach(function (b) {
      b.addEventListener('click', function () { addToCart(true).then(function (ok) { if (ok) window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout'; }); });
    });

    /* ---------- Share ---------- */
    root.querySelectorAll('[data-cdx-share]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        if (navigator.share) navigator.share({ title: document.title, url: location.href }).catch(function () {});
        else { navigator.clipboard && navigator.clipboard.writeText(location.href); }
      });
    });

    /* ---------- Modell-Dropdown (Größe/Modell) auf-/zuklappen ---------- */
    root.querySelectorAll('[data-model-toggle]').forEach(function (btn) {
      var wrap = btn.closest('[data-model-select]');
      if (!wrap) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = wrap.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) {
      root.querySelectorAll('[data-model-select].open').forEach(function (wrap) {
        if (!wrap.contains(e.target)) {
          wrap.classList.remove('open');
          var b = wrap.querySelector('[data-model-toggle]');
          if (b) b.setAttribute('aria-expanded', 'false');
        }
      });
    });

    /* ---------- In-Page-Anker (z. B. "Mehr Infos zu den Schlössern") sanft scrollen ---------- */
    root.querySelectorAll('[data-anchor-scroll]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var id = (el.getAttribute('href') || '').replace('#', '');
        if (!id) return;
        var target = document.getElementById(id);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });

    /* ---------- Liefermethoden-Modal ---------- */
    var deliveryModal = root.querySelector('[data-delivery-modal]');
    if (deliveryModal) {
      var lockDeliv = function (on) {
        document.documentElement.style.overflow = on ? 'hidden' : '';
        document.body.style.overflow = on ? 'hidden' : '';
      };
      var openDeliv = function () { deliveryModal.hidden = false; lockDeliv(true); };
      var closeDeliv = function () { deliveryModal.hidden = true; lockDeliv(false); };
      root.querySelectorAll('[data-delivery-open]').forEach(function (b) { b.addEventListener('click', openDeliv); });
      deliveryModal.querySelectorAll('[data-delivery-close]').forEach(function (b) { b.addEventListener('click', closeDeliv); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !deliveryModal.hidden) closeDeliv(); });
    }

    /* ---------- Angebot-Modal: Konfiguration (Varianten + AVIS + Zubehör) übernehmen ---------- */
    var offerModal = root.querySelector('[data-offer-modal]');
    if (offerModal) {
      var offerList = offerModal.querySelector('[data-offer-config-list]');
      var offerField = offerModal.querySelector('[data-offer-config-field]');
      var offerTotalEl = offerModal.querySelector('[data-offer-total]');
      var collectConfig = function () {
        var items = [];
        // Größe/Modell (Dropdown-Header hat kein data-option-selected)
        var sizeSel = root.querySelector('.bb-section--size .h .selected');
        if (sizeSel && sizeSel.textContent.trim()) items.push({ k: btT('cdx_product.size_model', 'Größe / Modell'), v: sizeSel.textContent.trim() });
        // Varianten-Optionen (Farbe, Schloss, …)
        root.querySelectorAll('.bb-section [data-option-selected]').forEach(function (el) {
          var sec = el.closest('.bb-section');
          var h = sec && sec.querySelector('.h');
          var optLbl = btT('cdx_product.option', 'Option');
          var label = h && h.childNodes[0] ? (h.childNodes[0].textContent || '').trim() : optLbl;
          var val = (el.textContent || '').trim();
          if (val) items.push({ k: label || optLbl, v: val });
        });
        // AVIS-Optionen
        (avisChips() || []).forEach(function (c) { items.push({ k: c.k || btT('cdx_product.configuration', 'Konfiguration'), v: c.v }); });
        // Zubehör
        Object.keys(accSelected).forEach(function (id) { var a = accSelected[id]; var q = a.qty || 1; items.push({ k: btT('cdx_product.accessories', 'Zubehör'), v: (q > 1 ? q + '× ' : '') + a.title }); });
        return items;
      };
      var grandTotal = function () {
        var mq = qty ? (parseInt(qty.value, 10) || 1) : 1;
        return mainPrice() * mq + accSum() + avisConfigAddon();
      };
      var populateOffer = function () {
        var items = collectConfig();
        if (offerList) {
          offerList.innerHTML = items.length ? items.map(function (it) {
            return '<span class="offer-ci"><span class="offer-ci-k">' + esc(it.k) + '</span><span class="offer-ci-v">' + esc(it.v) + '</span></span>';
          }).join('') : '<span class="offer-config-empty">' + esc(document.title) + '</span>';
        }
        var total = grandTotal();
        if (offerTotalEl) offerTotalEl.textContent = money(total);
        if (offerField) {
          var lines = items.map(function (it) { return it.k + ': ' + it.v; });
          lines.push(btT('cdx_product.total_price', 'Gesamtpreis') + ': ' + money(total));
          offerField.value = lines.join('\n');
        }
      };
      var lockScroll = function (on) {
        document.documentElement.style.overflow = on ? 'hidden' : '';
        document.body.style.overflow = on ? 'hidden' : '';
      };
      // Konfiguration ein-/ausklappen (Standard: eingeklappt, Preis auf einen Blick)
      var cfgToggle = offerModal.querySelector('[data-offer-config-toggle]');
      if (cfgToggle) {
        cfgToggle.addEventListener('click', function () {
          var wrap = cfgToggle.closest('.offer-config');
          var list = wrap && wrap.querySelector('[data-offer-config-list]');
          var open = wrap.classList.toggle('open');
          cfgToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (list) list.hidden = !open;
        });
      }
      var openOffer = function () { populateOffer(); offerModal.hidden = false; lockScroll(true); };
      var closeOffer = function () { offerModal.hidden = true; lockScroll(false); };
      // dokumentweit, damit auch Buttons außerhalb der ATF-Section (z. B. untere Lieferoptionen) das Modal öffnen
      document.addEventListener('click', function (e) { if (e.target.closest('[data-offer-open]')) { e.preventDefault(); openOffer(); } });
      offerModal.querySelectorAll('[data-offer-close]').forEach(function (b) { b.addEventListener('click', closeOffer); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !offerModal.hidden) closeOffer(); });
      // Nach erfolgreichem Absenden hat das Formular die Erfolgsmeldung gerendert → Modal automatisch öffnen
      if (offerModal.querySelector('[data-offer-success]')) { offerModal.hidden = false; lockScroll(true); }
    }

    /* ---------- Liefermodal → Angebot-Modal: schließt Liefermodal, öffnet Angebot mit Lieferart im Text ---------- */
    document.addEventListener('click', function (e) {
      var pf = e.target.closest('[data-offer-prefill]');
      if (!pf) return;
      e.preventDefault();
      if (typeof closeDeliv === 'function') closeDeliv();
      if (offerModal) {
        var body = offerModal.querySelector('[name="contact[body]"]');
        if (body) body.value = pf.getAttribute('data-offer-prefill') || '';
        if (typeof openOffer === 'function') openOffer();
      }
    });

    /* ---------- AVIS modal (anchor-based) + Gesamtpreis ---------- */
    var modal = avisModal;
    if (modal) {
      var anchor = avisAnchor;
      var mount = modal.querySelector('[data-avis-mount]');
      var ph = modal.querySelector('[data-avis-ph]');
      var openBtns = root.querySelectorAll('[data-avis-open]');
      var avisTotalEl = modal.querySelector('[data-avis-total]');
      var avisNoteEl = modal.querySelector('[data-avis-addon-note]');
      // AVIS hat Optionen, sobald im Mount Formularfelder gerendert wurden (= Set zugewiesen)
      function avisHasContent() { return !!(mount && mount.querySelector('input, select, textarea')); }
      function syncConfigUI() {
        var filled = avisHasContent();
        if (ph) ph.style.display = filled ? 'none' : '';
        /* „Weiter konfigurieren" nur anzeigen, wenn AVIS auch Optionen hat.
           Ueber das hidden-Attribut, nicht ueber style.display: der Knopf kommt
           aus dem Liquid bereits mit hidden, damit er auf Produkten ohne
           Optionen gar nicht erst aufblitzt. Mit style.display allein waere er
           sichtbar geblieben, weil hidden staerker ist. */
        openBtns.forEach(function (b) { b.hidden = !filled; b.style.display = ''; });
        /* Options-Kachel in der Zubehoer-Section (11.09.2026, Wunsch Chris): gleiche
           Regel wie der Knopf in der Buybox. Sie nennt die Optionsgruppen der App,
           und erst wenn es sie gibt, heisst die Section "Produktoptionen & Zubehoer".
           Hat das Produkt kein Zubehoer, steht die Section nur fuer die Kachel da. */
        var names = [];
        if (filled) {
          mount.querySelectorAll('.avp-option').forEach(function (g) {
            var l = avisGroupLabel(g);
            if (l && names.indexOf(l) < 0) names.push(l);
          });
        }
        document.querySelectorAll('[data-avis-open-ext]').forEach(function (t) {
          var wasHidden = t.hidden;
          t.hidden = !filled;
          var gl = t.querySelector('[data-avis-ext-groups]');
          if (gl && names.length) gl.textContent = names.slice(0, 3).join(' · ') + (names.length > 3 ? ' …' : '');
          /* Die Kachel kommt erst, wenn AVIS geantwortet hat, also nach dem ersten Bild. Der
             Browser haelt dann per Scroll-Anchoring die schon sichtbare erste Zubehoer-Kachel
             fest, und die Options-Kachel steht links ausserhalb des Streifens (Call 14.09.2026,
             Punkt 11). Deshalb beim Einblenden den Streifen an den Anfang setzen. */
          if (filled && wasHidden) {
            var strip = t.closest('.acc-grid');
            if (strip) { strip.scrollLeft = 0; strip.dispatchEvent(new Event('scroll')); }
          }
        });
        /* Nur die Ueberschrift der Zubehoer-Section (data-acc-heading). Bis 14.09.2026
           stand hier [data-acc-title] - das Attribut tragen auch die Plus-Knoepfe der
           Zubehoer-Kacheln als Produkttitel. textContent hat dort die SVG-Icons
           geloescht, uebrig blieben leere blaue Quadrate (Befund Chris, Call 14.09.). */
        document.querySelectorAll('[data-acc-heading]').forEach(function (h) {
          var alt = h.getAttribute('data-title-opts');
          if (!h.hasAttribute('data-title-base')) h.setAttribute('data-title-base', h.textContent);
          h.textContent = filled && alt ? alt : h.getAttribute('data-title-base');
        });
        document.querySelectorAll('[data-acc-opts-only]').forEach(function (s) { s.hidden = !filled; });
      }
      /* Einmal beim Start pruefen. Vorher lief syncConfigUI nur beim Oeffnen des
         Modals und aus dem MutationObserver am Mount - und der feuert nie, wenn
         AVIS fuer dieses Produkt gar kein Set hat. Genau dann blieb der Knopf
         stehen. */
      syncConfigUI();
      function updateAvisTotal() {
        var mq = qty ? (parseInt(qty.value, 10) || 1) : 1;
        /* Erst renderBundle: dort wird der Basisanteil des App-Aufpreises
           bestimmt. Die Notiz weist danach nur den Anteil aus, den der Kunde
           selbst dazukonfiguriert hat — der Gesamtpreis enthaelt weiter alles. */
        renderBundle();
        var cfg = avisConfigAddon();
        if (avisTotalEl) avisTotalEl.textContent = money(mainPrice() * mq + accSum() + cfg);
        if (avisNoteEl) avisNoteEl.textContent = cfg > 0 ? btT('cdx_product.incl_configuration', 'inkl. + {amount} Konfiguration', { amount: money(cfg) }) : '';
      }
      /* ---------- Gruppen-Navigation im Konfigurations-Modal ----------
         Jede `.avp-option` der App ist eine Optionsgruppe. Die Navigation wird
         daraus gebaut; die Zahl am Eintrag zaehlt die Felder, die vom
         Startzustand der Gruppe abweichen (= bewusst getroffene Auswahl).
         Der Startzustand haengt am Gruppenlabel, damit er ein Neu-Rendern der
         App (bedingte Logik) ueberlebt. */
      var cfgNav = modal.querySelector('[data-cfg-nav]');
      var cfgMain = modal.querySelector('[data-cfg-main]');
      var cfgGroupsEl = modal.querySelector('[data-cfg-groups]');
      var cfgGroups = [];    // { el, btn, initial }
      var cfgInitials = {};  // Gruppenlabel -> Startzustand
      // gleiche Titel wie in der Aufschluesselung, damit Navigation und Liste zusammenpassen
      function cfgLabel(g) { return avisGroupLabel(g); }
      function cfgFieldState(g) {
        var out = [];
        g.querySelectorAll('input, select, textarea').forEach(function (el) {
          // Felder der einsortierten Wunschfarbe zaehlen zu ihrer eigenen Gruppe,
          // die RAL-Suche in der Kachel zu gar keiner
          var w = el.closest('.cfg-wf, .cfg-wf-tile');
          if (w && w !== g) return;
          if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) out.push(el.name + '=' + el.value); }
          else if (el.value) out.push(el.name + '=' + el.value);
        });
        return out;
      }
      function cfgDiff(o) {
        var now = cfgFieldState(o.el), n = 0, i;
        for (i = 0; i < now.length; i++) { if (o.initial.indexOf(now[i]) < 0) n++; }
        return n;
      }
      /* AVIS haengt den Aufpreis als „(+49,00 €)" an — die Klammern raus, der
         Preis steht in der Kachel ohnehin als eigene Zeile unter dem Titel.
         Nur reine Textknoten anfassen, damit z. B. .apo-compare-price bleibt. */
      function cfgTidyPrices() {
        if (!cfgMain) return;
        /* .apo-title-addcharge steht sonst nur am Gruppentitel und bleibt dort
           in Klammern. In der Wunschfarbe-Kachel ist es die Preispille — dort
           also genauso entklammern wie die Wertpreise. */
        cfgMain.querySelectorAll('.money, .apo-money, .cfg-wf .apo-title-addcharge').forEach(function (el) {
          if (el.dataset.cdxTidy) return;
          el.dataset.cdxTidy = '1';
          if (!/^\(.*\)$/.test((el.textContent || '').trim())) return;
          // nur eigene Textknoten anfassen, verschachtelte Elemente (z. B. Streichpreis) bleiben
          var texts = Array.prototype.filter.call(el.childNodes, function (n) {
            return n.nodeType === 3 && n.nodeValue.trim();
          });
          if (!texts.length) return;
          texts[0].nodeValue = texts[0].nodeValue.replace('(', '');
          var last = texts[texts.length - 1];
          last.nodeValue = last.nodeValue.replace(/\)(\s*)$/, '$1');
        });
      }
      /* Preis an der Wert-Kachel nachtragen. Bei variantengebundenen Optionen
         („Gebuendeltes Produkt") rendert die App kein Preiselement, obwohl der
         Wert kostet — der Betrag steht nur in `data-variant-price` (Cent). Ohne
         das steht der Aufpreis nur unten in der Summe und der Kunde sieht an der
         Kachel nicht, was sie kostet. Klasse `apo-money`, damit die Pille genauso
         aussieht wie die von der App gelieferten Preise. */
      function cfgValuePrices() {
        if (!cfgMain) return;
        cfgMain.querySelectorAll('label input[data-variant-price]').forEach(function (inp) {
          var lbl = inp.closest('label');
          if (!lbl || lbl.dataset.cdxVprice) return;
          lbl.dataset.cdxVprice = '1';
          if (lbl.querySelector('.apo-money, .money')) return;   // App zeigt den Preis schon selbst
          var cents = Math.round(parseFloat(inp.getAttribute('data-variant-price')) || 0);
          if (cents <= 0) return;
          var s = document.createElement('span');
          s.className = 'apo-money cdx-vprice';
          s.textContent = '+ ' + money(cents);
          lbl.appendChild(s);
        });
      }
      /* RAL-Tabelle. Liegt als eigenes Asset (assets/cdx-ral.js, ~8 KB) und wird
         erst geladen, wenn ein Kunde das Feld zum ersten Mal aufmacht — auf der
         Produktseite selbst haengt sie an nichts. Die Adresse kommt aus einem
         Datenattribut, weil JS die Asset-URL des Themes nicht selbst bauen kann.
         Faellt der Ladeversuch aus (kein Netz, Asset fehlt), bleibt das Feld
         leer und der Farbwaehler tut es weiter — nichts geht dadurch kaputt. */
      var ralListe = null, ralLaden = null;
      function ralLoad() {
        if (ralListe) return Promise.resolve(ralListe);
        if (ralLaden) return ralLaden;
        var url = modal.getAttribute('data-cfg-ral-url');
        if (!url) return Promise.resolve(null);
        ralLaden = new Promise(function (fertig) {
          var s = document.createElement('script');
          s.src = url;
          s.onload = function () { ralListe = window.CDX_RAL || null; fertig(ralListe); };
          s.onerror = function () { fertig(null); };
          document.head.appendChild(s);
        });
        return ralLaden;
      }
      /* Treffer zu einer Eingabe: erst die Nummern, die so anfangen („30" ->
         3000, 3001 …), danach die Namen, in denen das Wort vorkommt („rot").
         Beides zusammen deckt beide Wege ab, auf denen ein Kunde sucht. */
      function ralSuche(q) {
        if (!ralListe) return [];
        q = String(q || '').toLowerCase().replace(/^ral\b/, '').replace(/\s+/g, ' ').trim();
        if (!q) return [];
        var nummern = [], namen = [];
        ralListe.forEach(function (r) {
          if (r[0].indexOf(q) === 0) nummern.push(r);
          else if (r[1].toLowerCase().indexOf(q) >= 0) namen.push(r);
        });
        return nummern.concat(namen).slice(0, 7);
      }
      /* Naechster RAL-Ton zu einer beliebigen Farbe. Verglichen wird in CIE-Lab
         (Delta E 1976) und nicht in RGB: RGB-Abstaende richten sich nach der Zahl,
         nicht nach dem, was das Auge als aehnlich sieht — ein dunkles Blau waere
         dort naeher an Schwarz als am naechsten Blau. Die Lab-Werte der Tabelle
         werden einmal berechnet und dann behalten. */
      function ralLab(hex) {
        var n = parseInt(hex.slice(1), 16);
        var c = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(function (v) {
          v /= 255;
          return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
        });
        // sRGB -> XYZ (D65) -> Lab
        var x = (c[0] * 0.4124 + c[1] * 0.3576 + c[2] * 0.1805) / 0.95047;
        var y = (c[0] * 0.2126 + c[1] * 0.7152 + c[2] * 0.0722);
        var z = (c[0] * 0.0193 + c[1] * 0.1192 + c[2] * 0.9505) / 1.08883;
        var f = function (t) { return t > 0.008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116; };
        x = f(x); y = f(y); z = f(z);
        return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
      }
      var ralLabs = null;
      function ralNaechster(hex) {
        if (!ralListe || !/^#[0-9a-f]{6}$/i.test(hex)) return null;
        if (!ralLabs) ralLabs = ralListe.map(function (r) { return ralLab(r[2]); });
        var l = ralLab(hex), best = null, bd = Infinity;
        for (var i = 0; i < ralLabs.length; i++) {
          var a = ralLabs[i];
          var d = (a[0] - l[0]) * (a[0] - l[0]) + (a[1] - l[1]) * (a[1] - l[1]) + (a[2] - l[2]) * (a[2] - l[2]);
          if (d < bd) { bd = d; best = ralListe[i]; }
        }
        return best;
      }
      /* Ein Klick irgendwo sonst schliesst das Aufklappfeld. Einmal am Dokument,
         weil die Kachel bei jedem Neu-Rendern der App neu entsteht. */
      document.addEventListener('click', function (e) {
        if (!wf.zu || !e.target || !e.target.closest) return;
        if (e.target.closest('.cfg-wf-tile')) return;
        wf.zu();
      });
      /* WUNSCHFARBE ALS FARBKACHEL (Rueckmeldung Leon, 25.08. und 10.09.2026)
         Der Farbwaehler ist in AVIS eine eigene Optionsgruppe und stand deshalb
         als eigener Block unter der Farbauswahl. Fuer den Kunden ist er aber nur
         eine weitere Farbe. Er wird darum als letzte Kachel in die Kachelreihe
         der Farbauswahl gehaengt — und zwar als dieselbe Kachel wie die festen
         Farben: gleicher Aufbau (Farbfeld, Titel, Preispille), gleiche Masse,
         gleicher Aussenabstand, gleicher Auswahlrand. Dass dahinter eine andere
         Optionsgruppe steckt, soll der Kunde nicht sehen; `.cfg-wf-tile` steht im
         CSS deshalb in denselben Regeln wie `label.avp-productoptionswatchwrapper`.

         Ein Klick auf die Kachel klappt darunter ein kleines Feld auf mit den
         zwei Wegen zu einer eigenen Farbe:
           - RAL-Nummer oder Farbname eintippen (Tabelle: assets/cdx-ral.js),
           - oder die Farbe frei waehlen ueber das Farbfeld der App.
         Das Feld liegt absolut, die Kachelreihe verrutscht dadurch nicht.

         Die Gruppe der App wird ins DOM VERSCHOBEN, nicht kopiert — ein Klon
         haette zwei Felder gleichen Namens ergeben, die App haette den falschen
         gelesen. Sie liegt unsichtbar ueber dem Farbfeld im aufgeklappten Feld:
         ein Klick darauf ist damit ein echter Klick auf `input[type=color]`, und
         nur aus einer echten Nutzerhandlung geht der Farbwaehler des Systems auf.

         Welche Gruppen gemeint sind, steht in den Section-Einstellungen (Wortteil
         im Gruppentitel). Findet der Wortteil den Waehler nicht — die Gruppe
         heisst im AVIS-Backend inzwischen anders, aus "RAL" wurde "Wunschfarbe" —,
         wird die Gruppe mit dem Farbfeld genommen; ein `input[type=color]` gibt
         es in keiner anderen.

         Zusammenspiel mit dem Rest: avisGroups() und cfgBuild() ueberspringen
         verschachtelte Gruppen. Beide kennen `cfg-wf` als Ausnahme, sonst faellt
         der Aufpreis der Wunschfarbe aus der Aufschluesselung.

         Die App rendert bei jeder Aenderung neu und baut ihre Knoten dabei neu
         auf. Deshalb laeuft das nach jedem Aufbau erneut, die Handler gehen ueber
         `wf` an die jeweils aktuelle Fassung (sonst haengen sie an Knoten, die
         nicht mehr im Dokument stehen), und was gewaehlt ist, steht nicht im
         Feld, sondern im Merker `wf.on`/`wf.ral`. */
      function cfgColorTile() {
        if (!cfgMain) return;
        /* Mehrere Wortteile mit "|" (28.10.2026: Gruppentitel sind in EN/FR/IT uebersetzt). */
        var woerter = function (a) { return (modal.getAttribute(a) || '').toLowerCase().split('|').map(function (w) { return w.trim(); }).filter(Boolean); };
        var zielWorte = woerter('data-cfg-color-group');
        var feldWorte = woerter('data-cfg-color-field');
        var trifft = function (lbl, ws) { return ws.some(function (w) { return lbl.indexOf(w) >= 0; }); };
        if (!zielWorte.length) return;
        var ziel = null, quelle = null;
        cfgGroups.forEach(function (o) {
          var lbl = (cfgLabel(o.el) || '').toLowerCase();
          if (!lbl) return;
          if (!quelle && trifft(lbl, feldWorte)) quelle = o.el;
          else if (!ziel && trifft(lbl, zielWorte)) ziel = o.el;
        });
        /* Der Wortteil kann auch danebengreifen ("RAL" steckt in
           "Zentralverriegelung"): eine Gruppe ohne Eingabefeld ist nicht der
           Farbwaehler. */
        if (quelle && !quelle.querySelector('input[type="color"], input[type="text"], textarea')) quelle = null;
        if (!quelle) {
          cfgGroups.forEach(function (o) {
            if (quelle || o.el === ziel) return;
            if (o.el.querySelector('input[type="color"]')) quelle = o.el;
          });
        }
        if (!ziel || !quelle || ziel === quelle || quelle.contains(ziel)) return;
        /* Die Kachelreihe der Zielgruppe: der naechste gemeinsame Kasten um ALLE
           Wert-Kacheln. Welches Element das ist, haengt vom Anzeigetyp der App ab
           (Radio, Pill, Swatch) und davon, ob jede Kachel noch einmal einzeln
           eingepackt ist — deshalb von der ersten Kachel nach oben suchen statt
           eine Klasse zu raten. :has() kann in aelteren Browsern werfen — dann
           bleibt alles, wie es ist. */
        var kacheln = [];
        try {
          kacheln = Array.prototype.slice.call(ziel.querySelectorAll('label:has(input[type="radio"]), label:has(input[type="checkbox"])'));
        } catch (e) { return; }
        kacheln = kacheln.filter(function (l) { return !l.closest('.cfg-wf'); });
        if (!kacheln.length) return;
        var reihe = kacheln[0].parentElement;
        while (reihe && reihe !== ziel && !kacheln.every(function (l) { return reihe.contains(l); })) reihe = reihe.parentElement;
        if (!reihe || reihe === quelle || quelle.contains(reihe)) return;

        /* ---- Kachel ---- */
        var tile = reihe.querySelector('.cfg-wf-tile');
        if (!tile) {
          tile = document.createElement('div');
          tile.className = 'cfg-wf-tile';
          tile.setAttribute('role', 'button');
          tile.setAttribute('tabindex', '0');
          tile.setAttribute('aria-expanded', 'false');
          tile.innerHTML =
            '<span class="avp-productoptionswatch cfg-wf-swatch"><span class="apo-color-image">&nbsp;</span></span>' +
            '<span class="swatch-variant-title"><span class="cfg-wf-name"></span> <span class="money apo-money cfg-wf-price" hidden></span></span>' +
            '<button type="button" class="cfg-wf-clear" aria-label="' + esc(btT('cdx_product.wf_remove', 'Wunschfarbe entfernen')) + '" title="' + esc(btT('cdx_product.wf_remove', 'Wunschfarbe entfernen')) + '">' +
              '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2.5 2.5 9.5 9.5M9.5 2.5 2.5 9.5"/></svg></button>' +
            '<div class="cfg-wf-pop" hidden>' +
              '<label class="cfg-wf-lab">' + esc(btT('cdx_product.ral_enter', 'RAL-Ton eingeben')) +
                '<input type="text" class="cfg-wf-ral" placeholder="' + esc(btT('cdx_product.ral_placeholder', 'z. B. 3011 oder Braunrot')) + '" autocomplete="off" spellcheck="false"></label>' +
              '<ul class="cfg-wf-hits"></ul>' +
              '<p class="cfg-wf-leer" hidden>' + esc(btT('cdx_product.ral_none', 'Kein RAL-Ton gefunden.')) + '</p>' +
              '<p class="cfg-wf-snap" hidden></p>' +
              '<div class="cfg-wf-free"><span class="cfg-wf-freetext">' + esc(btT('cdx_product.free_color', 'Oder Farbe frei wählen')) + '</span>' +
                '<span class="cfg-wf-holder"></span></div>' +
              '<p class="cfg-wf-hint">' + esc(btT('cdx_product.paint_hint', 'Lackiert wird nach RAL-Nummer. Die Farbe am Bildschirm ist nur eine Näherung.')) + '</p>' +
            '</div>';
        }
        if (tile.parentElement !== reihe) reihe.appendChild(tile);
        var holder = tile.querySelector('.cfg-wf-holder');
        quelle.classList.add('cfg-wf');
        if (quelle.parentElement !== holder) holder.appendChild(quelle);

        wf.group = quelle; wf.tile = tile; wf.ziel = ziel;
        wf.key = cfgLabel(quelle); wf.fixKey = cfgLabel(ziel);

        /* Als Kachel ist die Gruppe Teil der Farbauswahl — kein eigener Punkt
           mehr in der Sprungliste und keine eigene Optionsgruppe in der Zaehlung. */
        for (var i = cfgGroups.length - 1; i >= 0; i--) {
          if (cfgGroups[i].el !== quelle) continue;
          if (cfgGroups[i].btn && cfgGroups[i].btn.parentNode) cfgGroups[i].btn.parentNode.removeChild(cfgGroups[i].btn);
          cfgGroups.splice(i, 1);
        }
        if (cfgNav) cfgNav.hidden = cfgGroups.length < 2;
        if (cfgGroupsEl) cfgGroupsEl.textContent = cfgGroups.length === 1 ? btT('cdx_product.option_groups_one', '1 Optionsgruppe') : btT('cdx_product.option_groups_other', '{n} Optionsgruppen', { n: cfgGroups.length });

        var farbe = quelle.querySelector('input[type="color"]');
        var nameEl = tile.querySelector('.cfg-wf-name');
        var preisEl = tile.querySelector('.cfg-wf-price');
        var pop = tile.querySelector('.cfg-wf-pop');
        var ralFeld = tile.querySelector('.cfg-wf-ral');
        var hits = tile.querySelector('.cfg-wf-hits');
        var leer = tile.querySelector('.cfg-wf-leer');
        var snap = tile.querySelector('.cfg-wf-snap');
        var feuer = function (el) {
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        };
        /* Freifelder der Gruppe (aeltere AVIS-Sets hatten hier ein Textfeld fuer
           die RAL-Nummer). Gibt es eines und steht etwas darin, ist das die
           Wunschfarbe; sonst der Ton aus dem Farbfeld. */
        var texte = function () {
          return Array.prototype.filter.call(quelle.querySelectorAll('input[type="text"], input:not([type]), textarea'), function (i) { return !i.disabled; });
        };
        var textWert = function () {
          var v = '';
          texte().forEach(function (i) { if (i.value && String(i.value).trim()) v = String(i.value).trim(); });
          return v;
        };
        var festeRadios = function () {
          var out = [];
          ziel.querySelectorAll('input[type="radio"]').forEach(function (r) { if (!r.closest('.cfg-wf')) out.push(r); });
          return out;
        };
        /* Die Farbe, mit der die Gruppe aufgebaut wurde — bei AVIS die
           Standardfarbe ohne Aufpreis. cfgInitials haelt den Startzustand
           ohnehin fuer die Zaehler der Navigation. */
        var startRadio = function () {
          var rs = festeRadios(), r = null, init = cfgInitials[cfgLabel(ziel)] || [];
          if (!rs.length) return null;
          rs.forEach(function (x) { if (!r && init.indexOf(x.name + '=' + x.value) >= 0) r = x; });
          return r || rs[0];
        };
        var intern = false;   // eigene Umschaltung, nicht die Wahl des Kunden
        /* Beim Entfernen der Wunschfarbe geht es auf die Farbe zurueck, die
           vorher galt — sonst stuende die Farbauswahl leer da, obwohl sie eine
           Pflichtgruppe ist. */
        var zurueckRadio = function () {
          var rs = festeRadios(), r = null;
          if (!rs.length) return null;
          rs.forEach(function (x) { if (!r && wf.prev && x.value === wf.prev) r = x; });
          return r || startRadio();
        };
        /* Ohne Wahl zeigt das Farbfeld den Farbkreis (CSS-Vorgabe), mit Wahl den
           Ton. Der Titel ist derselbe Aufbau wie bei den festen Farben: mit
           RAL-Ton „Braunrot (RAL 3011)", frei gewaehlt „Wunschfarbe (#7A2A2A)". */
        var sync = function () {
          var ton = wf.on ? (wf.ral ? wf.ral.hex : (textWert() || (farbe ? farbe.value : ''))) : '';
          tile.classList.toggle('is-set', !!wf.on);
          ziel.classList.toggle('cfg-wf-aktiv', !!wf.on);
          if (wf.on && wf.ral) nameEl.textContent = wf.ral.name + ' (RAL ' + wf.ral.code + ')';
          else nameEl.textContent = (wf.key || btT('cdx_product.custom_color', 'Wunschfarbe')) + (ton ? ' (' + ton.toUpperCase() + ')' : '');
          var hex = /^#[0-9a-f]{3,8}$/i.test(ton) ? ton : (wf.on && farbe && farbe.value ? farbe.value : '');
          if (hex) tile.style.setProperty('--wf-farbe', hex);
          else tile.style.removeProperty('--wf-farbe');
          var pill = quelle.querySelector('.apo-title-addcharge');
          var txt = pill ? avisText(pill).replace(/^\(/, '').replace(/\)$/, '').trim() : '';
          preisEl.textContent = txt;
          preisEl.hidden = !txt;
        };
        /* EINE FARBE, NICHT ZWEI (Rueckmeldung Leon)
           Frueher stand das jeweils andere nur blass da und nahm keine Klicks an.
           Jetzt wird es wirklich abgewaehlt: Wunschfarbe an -> die feste Farbe
           geht auf die Standardfarbe zurueck (die Gruppe ist Pflicht, sonst haelt
           AVIS seinen eigenen Warenkorb-Button an), steht nicht mehr ausgewaehlt
           da und faehrt nicht mit (wfCleanProps). Umgekehrt bleibt der Ton im
           Waehler zwar stehen — ein `input[type=color]` laesst sich nicht leeren —,
           gilt aber nicht mehr und faehrt ebenfalls nicht mit. */
        var setzen = function (an) {
          intern = true;
          if (an) {
            var neutral = startRadio();
            festeRadios().forEach(function (r) {
              if (r.checked && r !== neutral) wf.prev = r.value;
            });
            if (neutral && !neutral.checked) { neutral.checked = true; feuer(neutral); }
          } else {
            wf.ral = null;
            texte().forEach(function (i) { if (i.value) { i.value = ''; feuer(i); } });
            var r = zurueckRadio();
            if (r && !r.checked) { r.checked = true; feuer(r); }
          }
          wf.on = !!an;
          intern = false;
          sync();
        };

        /* ---- Aufklappfeld ---- */
        var treffer = [];
        var zeichneTreffer = function () {
          hits.innerHTML = '';
          treffer.forEach(function (r) {
            var li = document.createElement('li');
            li.className = 'cfg-wf-hit';
            li.setAttribute('role', 'option');
            li.innerHTML = '<span class="cfg-wf-dot" style="background:' + r[2] + '"></span>' +
              '<span class="cfg-wf-hitname"></span><span class="cfg-wf-hitcode"></span>';
            li.querySelector('.cfg-wf-hitname').textContent = r[1];
            li.title = r[1] + ' (RAL ' + r[0] + ')';
            li.querySelector('.cfg-wf-hitcode').textContent = 'RAL ' + r[0];
            li.addEventListener('click', function (e) { e.stopPropagation(); ralNehmen(r); });
            hits.appendChild(li);
          });
          var q = (ralFeld.value || '').trim();
          leer.hidden = !(q && ralListe && !treffer.length);
        };
        var suchen = function () {
          treffer = ralSuche(ralFeld.value);
          zeichneTreffer();
        };
        /* RAL-Ton uebernehmen: der Hexwert geht ins Farbfeld der App (damit sie
           ihren Aufpreis rechnet und ihre Property fuehrt), die Nummer merkt sich
           `wf.ral` — sie ist das, was bestellt und lackiert wird, und geht so
           auch in den Warenkorb (wfCleanProps). */
        var ralNehmen = function (r) {
          snap.hidden = true;
          wf.ral = { code: r[0], name: r[1], hex: r[2] };
          if (farbe) { farbe.value = r[2].toLowerCase(); feuer(farbe); }
          else setzen(true);
          ralFeld.value = 'RAL ' + r[0];
          zu();
        };
        /* FREI GEWAEHLTE FARBE RASTET AUF RAL EIN (Rueckmeldung Leon)
           Lackiert wird nach RAL-Nummer — eine Hausnummer wie #3E9BD2 kann die
           Lackiererei nicht mischen. Was der Kunde im Farbwaehler des Systems
           aussucht, wird deshalb auf den naechsten RAL-Ton gelegt, und die Kachel
           sagt, welcher daraus geworden ist. Fehlt die Tabelle (Asset nicht
           geladen), bleibt die frei gewaehlte Farbe stehen, statt die Auswahl zu
           verschlucken. */
        var einrasten = function (hex) {
          ralLoad().then(function () {
            var r = ralNaechster(hex);
            if (!r) { setzen(true); return; }
            wf.ral = { code: r[0], name: r[1], hex: r[2] };
            snap.hidden = false;
            snap.textContent = btT('cdx_product.ral_nearest', 'Nächster RAL-Ton zu {hex}: {name} (RAL {code}).', { hex: hex.toUpperCase(), name: r[1], code: r[0] });
            ralFeld.value = 'RAL ' + r[0];
            suchen();
            if (farbe && farbe.value.toLowerCase() !== r[2].toLowerCase()) { farbe.value = r[2].toLowerCase(); feuer(farbe); }
            else setzen(true);
          });
        };
        /* Wert vor dem Oeffnen des Systemwaehlers merken: bricht der Kunde dort ab,
           stellt der Browser den alten Wert wieder her und meldet das als Aenderung.
           Ohne diesen Vergleich waere ein Abbruch eine Auswahl — beim Startwert
           #000000 also ungewollt Tiefschwarz. */
        holder.onmousedown = function () { wf.vorher = farbe ? farbe.value : ''; };
        var platzieren = function () {
          tile.classList.remove('is-up');
          if (!cfgMain) return;
          var box = cfgMain.getBoundingClientRect(), p = pop.getBoundingClientRect(), t = tile.getBoundingClientRect();
          // Kein Platz nach unten, aber nach oben: Feld ueber die Kachel klappen
          if (p.bottom > box.bottom - 8 && t.top - box.top > p.height + 8) tile.classList.add('is-up');
        };
        var auf = function () {
          if (!pop.hidden) return;
          pop.hidden = false;
          tile.classList.add('is-open');
          tile.setAttribute('aria-expanded', 'true');
          platzieren();
          ralLoad().then(function () { suchen(); });
          try { ralFeld.focus({ preventScroll: true }); } catch (e) { ralFeld.focus(); }
        };
        var zu = function () {
          if (pop.hidden) return;
          pop.hidden = true;
          tile.classList.remove('is-open', 'is-up');
          tile.setAttribute('aria-expanded', 'false');
        };
        wf.zu = zu;

        /* Handler ueber `wf`, damit sie nach einem Neu-Rendern der App auf die
           neuen Knoten zeigen und nicht auf die weggeworfenen. */
        wf.set = setzen;
        wf.sync = sync;
        wf.feld = function (e) {
          var t = e.target;
          if (!t || intern || wf.reset) return;
          if (t === farbe || t.type === 'color') {
            /* Steht schon der Ton des RAL-Eintrags im Feld, ist nichts zu tun —
               sonst auf den naechsten RAL-Ton einrasten. */
            if (wf.ral && String(t.value).toLowerCase() === wf.ral.hex.toLowerCase()) { setzen(true); return; }
            // Abgebrochener Waehler: derselbe Wert wie vorher, nichts gewaehlt
            if (!wf.on && wf.vorher && String(t.value).toLowerCase() === String(wf.vorher).toLowerCase()) return;
            wf.ral = null;
            einrasten(String(t.value));
            return;
          }
          if (t.type === 'text' || t.tagName === 'TEXTAREA' || !t.getAttribute('type')) setzen(!!textWert());
        };
        wf.fest = function (e) {
          var t = e.target;
          if (intern || wf.reset) return;
          if (!t || t.type !== 'radio' || !t.checked || t.closest('.cfg-wf')) return;
          wf.prev = t.value;
          /* Feste Farbe gewaehlt -> die Wunschfarbe gilt nicht mehr. */
          if (wf.on) {
            wf.on = false;
            wf.ral = null;
            intern = true;
            texte().forEach(function (i) { if (i.value) { i.value = ''; feuer(i); } });
            intern = false;
          }
          ziel.classList.remove('cfg-wf-aktiv');
          zu();
          sync();
        };
        if (!quelle.dataset.cdxWfFeld) {
          quelle.dataset.cdxWfFeld = '1';
          quelle.addEventListener('input', function (e) { if (wf.feld) wf.feld(e); });
          quelle.addEventListener('change', function (e) { if (wf.feld) wf.feld(e); });
        }
        if (!ziel.dataset.cdxWfExkl) {
          ziel.dataset.cdxWfExkl = '1';
          ziel.addEventListener('change', function (e) { if (wf.fest) wf.fest(e); });
        }
        /* Die Kachel ist die Klickflaeche fuer das Feld. Klicks im Feld selbst
           duerfen es nicht wieder zuklappen. */
        tile.onclick = function (e) {
          if (e.target.closest('.cfg-wf-clear')) return;
          if (e.target.closest('.cfg-wf-pop')) return;
          if (pop.hidden) auf(); else zu();
        };
        tile.onkeydown = function (e) {
          if (e.target !== tile) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (pop.hidden) auf(); else zu(); }
        };
        pop.onkeydown = function (e) {
          if (e.key === 'Escape') { e.stopPropagation(); zu(); tile.focus(); return; }
          if (e.key === 'Enter' && e.target === ralFeld) {
            e.preventDefault();
            if (treffer.length) ralNehmen(treffer[0]);
          }
        };
        ralFeld.oninput = suchen;
        /* Abwaehlen: bei den festen Farben uebernimmt das die naechste Wahl —
           Radios. Die Wunschfarbe hat keine solche Nachbarwahl, ein Farbfeld ist
           nie leer, deshalb der Knopf in der Kachel. Er erscheint erst, wenn eine
           Wunschfarbe gilt. Als Zuweisung statt addEventListener, damit immer die
           aktuelle Fassung daran haengt. */
        tile.querySelector('.cfg-wf-clear').onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          ralFeld.value = '';
          snap.hidden = true;
          suchen();
          zu();
          setzen(false);
        };
        if (wf.ral && ralFeld.value === '') ralFeld.value = 'RAL ' + wf.ral.code;
        sync();
      }
      /* Mengen-Optionen: AVIS rendert dafuer nur ein nacktes Zahlenfeld — rechts
         steht ein leerer Kasten, dem man nicht ansieht, dass eine Stueckzahl
         hinein gehoert. Daraus wird hier ein beschrifteter Stepper. Die App
         rendert bei jeder Aenderung neu, deshalb laeuft das nach jedem Aufbau
         erneut; bereits umgebaute Felder tragen ein Flag. */
      function cfgQuantities() {
        if (!cfgMain) return;
        cfgMain.querySelectorAll('.ap-options__quantity-container .avp-quantity-input').forEach(function (inp) {
          var box = inp.closest('.ap-options__quantity-container');
          var sync = function () {
            var n = parseFloat(inp.value) || 0;
            if (box) box.classList.toggle('cdx-qty-set', n > 0);
            var minus = inp.parentNode && inp.parentNode.firstChild;
            if (minus && minus.tagName === 'BUTTON') minus.disabled = n <= (parseFloat(inp.getAttribute('min')) || 0);
          };
          if (inp.dataset.cdxQty) { sync(); return; }
          inp.dataset.cdxQty = '1';
          if (inp.getAttribute('max') === 'undefined') inp.removeAttribute('max');  // ungueltiges Attribut der App
          if (!inp.getAttribute('placeholder')) inp.setAttribute('placeholder', '0');
          if (!inp.getAttribute('min')) inp.setAttribute('min', '0');
          var step = function (delta) {
            var min = parseFloat(inp.getAttribute('min')); if (isNaN(min)) min = 0;
            var max = parseFloat(inp.getAttribute('max'));
            var n = (parseFloat(inp.value) || 0) + delta;
            if (n < min) n = min;
            if (!isNaN(max) && n > max) n = max;
            inp.value = n;
            inp.dispatchEvent(new Event('input', { bubbles: true }));
            inp.dispatchEvent(new Event('change', { bubbles: true }));
            sync();
          };
          var mk = function (txt, aria, delta) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cdx-qty-btn';
            b.setAttribute('aria-label', aria);
            b.textContent = txt;
            b.addEventListener('click', function () { step(delta); });
            return b;
          };
          var field = document.createElement('div');
          field.className = 'cdx-qty-field';
          var cap = document.createElement('span');
          cap.className = 'cdx-qty-cap';
          cap.textContent = btT('cdx_product.quantity', 'Menge');
          var wrap = document.createElement('div');
          wrap.className = 'cdx-qty';
          inp.parentNode.insertBefore(field, inp);
          field.appendChild(cap);
          field.appendChild(wrap);
          wrap.appendChild(mk('−', btT('cdx_product.qty_decrease', 'Menge verringern'), -1));
          wrap.appendChild(inp);
          wrap.appendChild(mk('+', btT('cdx_product.qty_increase', 'Menge erhöhen'), 1));
          inp.addEventListener('input', sync);
          sync();
        });
      }
      function cfgSync() {
        cfgGroups.forEach(function (o) {
          if (!o.btn) return;
          var n = cfgDiff(o);
          o.btn.querySelector('.n').textContent = n;
          o.btn.classList.toggle('is-set', n > 0);
        });
      }
      function cfgSpy() {
        if (!cfgNav || !cfgGroups.length || !cfgMain) return;
        var edge = cfgMain.getBoundingClientRect().top + 24, act = 0;
        cfgGroups.forEach(function (o, i) { if (o.el.getBoundingClientRect().top <= edge) act = i; });
        cfgGroups.forEach(function (o, i) { if (o.btn) o.btn.classList.toggle('is-active', i === act); });
      }
      /* Die Navigation ist optional (Section-Setting). Ohne sie laufen Gruppenzahl
         und Preis-Aufbereitung trotzdem — nur die Sprungliste entfaellt. */
      function cfgBuild() {
        if (!cfgMain) return;
        var groups = [];
        cfgMain.querySelectorAll('.avp-option').forEach(function (g) {
          if (g.classList.contains('ap-options__hidden-field-container')) return;
          // verschachtelte Gruppen (Option Group der App) nicht doppelt listen,
          // die einsortierte Wunschfarbe ausgenommen (siehe avisGroups)
          if (g.parentElement && g.parentElement.closest('.avp-option') && !g.classList.contains('cfg-wf')) return;
          if (cfgLabel(g)) groups.push(g);
        });
        if (cfgNav) cfgNav.innerHTML = '';
        cfgGroups = groups.map(function (g) {
          var key = cfgLabel(g);
          if (!cfgInitials[key]) cfgInitials[key] = cfgFieldState(g);
          var btn = null;
          if (cfgNav) {
            btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'cfg-navitem';
            btn.innerHTML = '<span class="dot"></span><span class="lbl"></span><span class="n">0</span>';
            btn.querySelector('.lbl').textContent = key;
            btn.addEventListener('click', function () {
              cfgMain.scrollTop += g.getBoundingClientRect().top - cfgMain.getBoundingClientRect().top - 8;
            });
            cfgNav.appendChild(btn);
          }
          return { el: g, btn: btn, initial: cfgInitials[key] };
        });
        // Bei nur einer Gruppe bringt die Navigation nichts
        if (cfgNav) cfgNav.hidden = cfgGroups.length < 2;
        if (cfgGroupsEl) {
          var n = cfgGroups.length;
          cfgGroupsEl.textContent = n === 1 ? btT('cdx_product.option_groups_one', '1 Optionsgruppe') : btT('cdx_product.option_groups_other', '{n} Optionsgruppen', { n: n });
          cfgGroupsEl.hidden = !n;
        }
        // cfgColorTile vor cfgTidyPrices: erst danach traegt die Gruppe `cfg-wf`,
        // und nur so entklammert cfgTidyPrices auch ihre Preispille.
        cfgValuePrices(); cfgColorTile(); cfgTidyPrices(); cfgQuantities(); cfgSync(); cfgSpy();
      }
      if (cfgMain) {
        var cfgSpyTick = false;
        cfgMain.addEventListener('scroll', function () {
          if (cfgSpyTick) return;
          cfgSpyTick = true;
          requestAnimationFrame(function () { cfgSpyTick = false; cfgSpy(); });
        });
      }

      function openModal() { syncConfigUI(); updateAvisTotal(); modal.hidden = false; document.body.style.overflow = 'hidden'; cfgSpy(); }
      function closeModal() { modal.hidden = true; document.body.style.overflow = ''; }
      openBtns.forEach(function (b) { b.addEventListener('click', openModal); });
      modal.querySelectorAll('[data-avis-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
      var applyBtn = modal.querySelector('[data-avis-apply]');
      if (applyBtn) applyBtn.addEventListener('click', closeModal);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
      // AVIS-Optionen aendern sich -> Button/Platzhalter + Gesamtpreis (Modal + Buybox) aktualisieren
      modal.addEventListener('change', function () { updateAvisTotal(); cfgTidyPrices(); cfgSync(); });
      modal.addEventListener('input', function () { updateAvisTotal(); cfgSync(); });
      document.addEventListener('variant:changed', updateAvisTotal);
      if (mount && window.MutationObserver) {
        // AVIS rendert asynchron und nach -> Navigation erst neu bauen, wenn das Markup ruht
        var cfgTimer = null;
        new MutationObserver(function () {
          syncConfigUI(); updateAvisTotal();
          clearTimeout(cfgTimer);
          cfgTimer = setTimeout(cfgBuild, 350);
        }).observe(mount, { childList: true, subtree: true });
      }
      syncConfigUI(); updateAvisTotal(); cfgBuild();
    }

    /* ---------- Schloss aus der Schlossübersicht auswählen -> Variante oben umschalten ---------- */
    function markSelectedLock() {
      var selVals = [];
      root.querySelectorAll('[data-option-value].selected').forEach(function (b) { selVals.push(b.dataset.value); });
      document.querySelectorAll('[data-cdx-select-lock]').forEach(function (btn) {
        var on = selVals.indexOf(btn.getAttribute('data-value')) !== -1;
        btn.classList.toggle('is-selected', on);
        var lbl = btn.querySelector('.sl-select-lbl');
        if (lbl) lbl.textContent = on ? btT('cdx_product.lock_selected', 'Ausgewählt') : btT('cdx_product.lock_select', 'Auswählen');
      });
    }
    document.addEventListener('click', function (e) {
      var sel = e.target.closest('[data-cdx-select-lock]');
      if (!sel) return;
      e.preventDefault();
      var val = sel.getAttribute('data-value');
      var target = null;
      root.querySelectorAll('[data-option-value]').forEach(function (b) { if (b.dataset.value === val) target = b; });
      if (target) {
        target.click();
        var bb = root.querySelector('.bb') || root;
        if (bb.scrollIntoView) bb.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    document.addEventListener('variant:changed', markSelectedLock);
    markSelectedLock();

    /* ---------- Trust-USPs: Mobile-Karussell (1 Item, 3s, Dots) ---------- */
    (function () {
      var tb = root.querySelector('.trust-bar');
      if (!tb) return;
      var items = Array.prototype.slice.call(tb.querySelectorAll('.ti'));
      if (items.length < 2) return;
      var dots = document.createElement('div');
      dots.className = 'trust-dots';
      items.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'trust-dot'; d.setAttribute('aria-label', btT('cdx_product.benefit_n', 'Vorteil {n}', { n: i + 1 }));
        d.addEventListener('click', function () { go(i); });
        dots.appendChild(d);
      });
      tb.parentNode.insertBefore(dots, tb.nextSibling);
      var dotEls = Array.prototype.slice.call(dots.children);
      var cur = 0, timer = null;
      function render() { items.forEach(function (it, i) { it.classList.toggle('is-active', i === cur); }); dotEls.forEach(function (d, i) { d.classList.toggle('active', i === cur); }); }
      function go(i) { cur = (i + items.length) % items.length; render(); restart(); }
      function isMobile() { return window.matchMedia('(max-width:749px)').matches; }
      function restart() { if (timer) clearInterval(timer); if (isMobile()) timer = setInterval(function () { go(cur + 1); }, 3000); }
      render(); restart();
      window.addEventListener('resize', restart);
    })();
  }

  function boot() { document.querySelectorAll('[data-cdx-pdp]').forEach(initPDP); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
